/* global angular, $ */
// Create templates module for ngTemplates to attach to
angular.module('ua5Templates', []);
// start module declaration
angular.module('ua5App.home', []);
angular.module('ua5App.about', []);
angular.module('ua5App.contribute', []);
angular.module('ua5App.artworks', []);
angular.module('ua5App.terms', []);
// end module declaration
// Create parent module for application
angular.module('ua5App', [
    'ngFileUpload',
    'monospaced.elastic',
    'ngResource',
    'ngSanitize',
    'ngTouch',
    'ngAnimate',
    'ua5Templates',
    'ui.router',
    'angulartics',
    'angulartics.google.analytics',
    'angular-loading-bar',
    'angularModalService',
    'ngMeta',
    // start add states as app dependency
    'ua5App.terms',
    'ua5App.artworks',
    'ua5App.contribute',
    'ua5App.about',
    'ua5App.home'
    // end add states as app dependency
])
    .constant('BREAKPOINTS', {
        PHONE_ONLY: 599,
        TABLET_PORTRAIT_UP: 600,
        TABLET_LANDSCAPE_UP: 900,
        DESKTOP_UP: 1200,
        BIG_DESKTOP_UP: 1800
    })
    .config(['$analyticsProvider', '$locationProvider', 'ngMetaProvider', function($analyticsProvider, $locationProvider, ngMetaProvider) {
        $locationProvider.html5Mode(true);
        // Prevents bounce rate of 0.01
        $analyticsProvider.firstPageview(false);
        ngMetaProvider.setDefaultTitle('Artifax — Fax Congress with Art');
        ngMetaProvider.setDefaultTag('url', 'http://mysite.com');
        ngMetaProvider.setDefaultTag('description', 'Page description');
        ngMetaProvider.setDefaultTag('image', 'http://mysite.com/assets/img/share.jpg');
    }])
    .run(['ngMeta', '$animate', function(ngMeta, $animate) {
        ngMeta.init();
        $animate.enabled(false);
    }])
    .directive('app', ['$rootScope', '$animate', '$window', '$location', 'BrowserFactory', function($rootScope, $animate, $window, $location, BrowserFactory) {
        return {
            link: function($scope, $element, $attrs) {
                var $$window;
                var firstLoad;
                var isFirefox = BrowserFactory.isFirefox();
                var isSafari = BrowserFactory.isSafari();
                var isIE = BrowserFactory.isExplorer() || BrowserFactory.isEdge();
                var browserSpecificStyles;
                var browserSpecificLineheight;
                firstLoad = true;
                $$window = $(window);

                function forceSSL() {
                    if ($location.protocol() !== 'https' && $location.host() === 'artifax.us') {
                        $window.location.href = $location.absUrl().replace('http', 'https');
                    }
                }
                forceSSL();

                $$window.on('resize', function() {
                    $rootScope.$broadcast('app:resized');
                });
                $$window.on('click', function(e) {
                    $rootScope.$broadcast('app:clicked', e.target);
                });
                $$window.on('scroll', function(e) {
                    $rootScope.$broadcast('app:scrolled');
                });
                $$window.on('keydown', function(e) {
                    var ESCAPE = 27;
                    var keyCode;
                    keyCode = e.keyCode;
                    // Escape key
                    if (keyCode === ESCAPE) {
                        $rootScope.$broadcast('app:escape:pressed');
                    }
                });
                $rootScope.$on('$stateChangeSuccess', function(e, toState, toStateParams, fromState) {
                    var regex = /^([^.]*).*/;
                    var toStateName = toState.name;
                    var toStateParent = toStateName.match(regex)[1];
                    $rootScope.pageClass = 'page-' + toState.name.replace('.', '-');
                    // If going directly to child from non-parent, just show
                    // child.
                    if (fromState !== toStateParent) {
                        setTimeout(function() {
                            $('[ui-view] [ui-view]').css({
                                opacity: 1,
                                position: 'static'
                            });
                        }, 1);
                    }
                    if (firstLoad) {
                        $('[ui-view]').css({
                            opacity: 1,
                            position: 'static'
                        });
                        $animate.enabled(true);
                        if (isFirefox || isSafari || isIE) {
                            browserSpecificStyles = document.createElement('style');
                            browserSpecificStyles.appendChild(document.createTextNode(''));
                            document.head.appendChild(browserSpecificStyles);

                            if (isIE) {
                                browserSpecificStyles.sheet.insertRule('.shape-logo__path { fill: #2a2a2a !important; transition: fill 0.3s 1s }', 0);
                                browserSpecificStyles.sheet.insertRule('.logo.intro-showing .shape-logo__path { fill: #d5d5d5 !important; }', 1);
                            } else {
                                browserSpecificLineheight = isFirefox ? '2.1rem' : '2.17rem';
                                browserSpecificStyles.sheet.insertRule('textarea { line-height: ' + browserSpecificLineheight + ' !important; }', 0);
                            }

                        }
                        firstLoad = false;
                    }
                });
            }
        };
    }])
;

/* global angular, TweenMax, Quint */
angular.module('ua5App')
    // Fade out old state then fade in the new state
    .animation('.fade-child', [function() {
        var FADE_SPEED = 0.5;
        return {
            enter: function(element, doneFn) {
                TweenMax.to(element, FADE_SPEED, {
                    alpha: 1,
                    onComplete: function() {
                        TweenMax.set(element, {
                            position: 'static'
                        });
                        doneFn();
                    },
                    ease: Quint.easeInOut
                });
            },
            leave: function(element, doneFn) {
                TweenMax.to(element, FADE_SPEED, {
                    alpha: 0,
                    onComplete: doneFn,
                    ease: Quint.easeInOut
                });
            }
        };
    }])
;

/* global angular, TweenMax, Quint */
angular.module('ua5App')
    // Fade out old state then fade in the new state
    .animation('.fade', [function() {
        var FADE_SPEED = 0.5;
        return {
            enter: function(element, doneFn) {
                TweenMax.to(element, FADE_SPEED, {
                    delay: FADE_SPEED,
                    alpha: 1,
                    onComplete: function() {
                        TweenMax.set(element, {
                            position: 'static'
                        });
                        doneFn();
                    },
                    ease: Quint.easeInOut
                });
            },
            leave: function(element, doneFn) {
                TweenMax.to(element, FADE_SPEED, {
                    alpha: 0,
                    onComplete: function() {
                        document.body.scrollTop = 0;
                        document.documentElement.scrollTop = 0;
                        doneFn();
                    },
                    ease: Quint.easeInOut
                });
            }
        };
    }])
;

/* global angular */
angular.module('ua5App')
    .directive('artwork', ['$timeout', function($timeout) {
        return {
            restrict: 'A',
            scope: {
                artworkData: '='
            },
            templateUrl: 'components/artwork/artwork.html',
            link: function($scope, element, attrs) {}
        };
    }])
;

/* global angular, $, TweenMax */
angular.module('ua5App')
    .directive('contactForm', ['$timeout', function($timeout) {
        return {
            restrict: 'A',
            templateUrl: 'components/contact-form/contact-form.html',
            link: function($scope, element, attrs) {
                $scope.formSubmit = function(model) {
                    $scope.disableButton = true;

                    //Check that required fields are filed in
                    if (!model || !model.name || !model.email || !model.message) {
                        $scope.formSubmitError = 'Please fill in required fields.';
                        $scope.disableButton = false;
                        return false;
                    }

                    //submit form & display success message
                    $.ajax({
                        type: 'POST',
                        url: 'https://liveformhq.com/form/059c7668-40ca-4d09-9cea-b0edb9a958e4',
                        data: model
                    }).done(function(response) {
                        //Reveal success response
                        TweenMax.to($('.contact-form'), 0.2, {display: 'none'});
                        TweenMax.to($('.contact-form__succcess'), 0.2, {display: 'block'});
                    }).fail(function(error) {
                        // $scope.formSubmitError = 'Oops! Something seems to have gone wrong, please try again.';
                        // $scope.disableButton = false;
                        //Reveal success response
                        TweenMax.to($('.contact-form'), 0.2, {display: 'none'});
                        TweenMax.to($('.contact-form__succcess'), 0.2, {display: 'block'});
                    });
                };
            }
        };
    }])
;

/* global angular, $, TweenMax */
angular.module('ua5App')
    .directive('contributeForm', ['$timeout', 'Upload', function($timeout, Upload) {
        return {
            restrict: 'A',
            templateUrl: 'components/contribute-form/contribute-form.html',
            link: function($scope, element, attrs) {
                $scope.formSubmit = function(model) {
                    //TODO handle form submission
                };

                $scope.agreed = false;
                $scope.agreeToTerms = function() {
                    $scope.agreed = !$scope.agreed;
                };

                $scope.mediaValidate = function(file) {
                    var invalidMediaType = true;

                    if (file && file.type) {
                        //determine file type
                        //only accept Image: .jpg
                        if (file.type === 'image/jpeg' || file.type === 'image/jpg') {
                            invalidMediaType = false;
                        }
                    }

                    //dont allow invalid file type && display error message
                    if (invalidMediaType) {
                        $scope.mediaFileError = 'Only JPG Images are allowed.';
                        return false;
                    } else {
                        $scope.mediaFileError = null;
                        return true;
                    }
                };

                $scope.uploadMedia = function(data, file) {
                    $scope.disableButton = true;

                    //Validate fields
                    if (!data.name || !data.email || !data.title || !file) {
                        $scope.disableButton = true;
                        $scope.formSubmitError = 'Please fill in required fields.';
                    } else {
                        Upload.upload({
                            url: 'https://liveformhq.com/form/059c7668-40ca-4d09-9cea-b0edb9a958e4',
                            data: {name: data.name, email: data.email, title: data.title, file: file}
                        }).then(function(response) {
                            //Reveal success response
                            TweenMax.to($('.contribute-form'), 0.2, {display: 'none'});
                            TweenMax.to($('.contribute-form__succcess'), 0.2, {display: 'block'});
                        }, function(error) {
                            //Reveal success response
                            TweenMax.to($('.contribute-form'), 0.2, {display: 'none'});
                            TweenMax.to($('.contribute-form__succcess'), 0.2, {display: 'block'});
                            // $scope.disableButton = false;
                            // $scope.formSubmitError = 'Whoops! Something went wrong, please try again.';
                        });
                    }
                };
            }
        };
    }])
;

/* global angular, $, moment */
angular.module('ua5App')
    .directive('faxGenerator', ['$rootScope', '$q', function($rootScope, $q) {
        return {
            restrict: 'A',
            templateUrl: 'components/fax-generator/fax-generator.html',
            link: function($scope, element, attrs) {
                var PAD = 22.5;
                var canvas = $('.canvas', element)[0];
                var ctx = canvas.getContext('2d');
                var artwork;
                var signature;

                function draw() {

                    $scope.faxArtwork = $scope.faxArtwork || {};
                    $scope.selectedRepresentative = $scope.selectedRepresentative || {};
                    $scope.name = $scope.name || {};

                    var totalY = PAD;
                    var image1 = $q.defer();
                    var image2 = $q.defer();
                    var registered = $scope.registered ? 'I am registered to vote' : '';
                    var title = $scope.title || '';
                    var artworkTitle = $scope.faxArtwork.title || '';
                    var artist = $scope.faxArtwork.artist || '';
                    var repPrefix =  $scope.selectedRepresentative.prefix || '';
                    var repName = $scope.selectedRepresentative.name || '';
                    var message = $scope.message || '';
                    var firstName = $scope.name.first || '';
                    var lastName = $scope.name.last || '';
                    var address = $scope.address || '';

                    // Debug:
                    // var registered = $scope.registered ? 'I am registered to vote' : '';
                    // var title = $scope.title || 'End Border Separations – Reunite Families One more line here';
                    // var artworkTitle = $scope.faxArtwork.title || 'Life Mask of Abraham Lincoln, 1860/2017';
                    // var artist = $scope.faxArtwork.artist || 'Rachel Eulena Williams';
                    // var repPrefix =  $scope.selectedRepresentative.prefix || 'Senator';
                    // var repName = $scope.selectedRepresentative.name || 'Dianne Feinstein';
                    // var message = $scope.message || 'As your constituent, I am writing to urge you to take action in reuniting families separated by the Trump administration’s border policy. The executive order reversing this separation policy, does nothing to address the situation of the thousands of children already separated from their parents. The American Medical Association has spoken out against the physical and emotional trauma a child faces when forcibly separated from their family. Doctors, psychologists, and child advocates have warned that this trauma may have lifelong implications. Thus, I hope that you consider creating legislation that would reunite these children with their family. Thank you.';
                    // var firstName = $scope.name.first || 'Jason-Randal-Evans-The 3rd, Jr.';
                    // var lastName = $scope.name.last || 'Casablanca-Henry-The-8th Knownly Fellweathers';
                    // var address = $scope.zipcode || "14724 Sunset Blvd Little Longer, Pacific Palisades Long City Name, CA 90272-8342, USA";
                    var date = moment().format('ll');

                    function wrapText(context, text, x, y, maxWidth, lineHeight) {
                        var words = text.split(' ');
                        var line = '';

                        for (var n = 0; n < words.length; n++) {
                            var testLine = line + words[n] + ' ';
                            var metrics = context.measureText(testLine);
                            var testWidth = metrics.width;
                            if (testWidth > maxWidth && n > 0) {
                                context.fillText(line, x, y);
                                line = words[n] + ' ';
                                y += lineHeight;
                            } else {
                                line = testLine;
                            }
                        }
                        context.fillText(line, x, y);
                        totalY = y + lineHeight;
                    }

                    ctx.clearRect(0, 0, canvas.width, canvas.height);
                    artwork = new Image();
                    artwork.onload = function() {
                        image1.resolve();
                    };
                    artwork.src = $scope.faxArtwork.image || '/assets/images/artworks/small/A-New-Home---Alexandra-Velasco.jpg';
                    signature = new Image();
                    signature.onload = function() {
                        image2.resolve();
                    };
                    signature.src = $scope.signatureImage || '/assets/images/sign.png';
                    $q.all([image1.promise, image2.promise]).then(function() {
                        var tempy;
                        canvas.width = 1275;
                        canvas.height = 1650;
                        ctx.fillStyle = '#fff';
                        ctx.fillRect(0, 0, canvas.width, canvas.height);
                        ctx.fillStyle = '#000';
                        ctx.font = '30px Poppins';
                        totalY += 49;
                        // we don't want this to affect the height of text
                        var cachedY = totalY;
                        wrapText(ctx, title, PAD, totalY, 540, 49);
                        totalY = cachedY;
                        ctx.font = '22.5px Poppins';
                        ctx.fillText('Title of artwork:', 580, totalY);
                        ctx.fillText('Artwork by:', 980, totalY);
                        tempy = totalY += 30;
                        wrapText(ctx, artworkTitle, 580, tempy, 350, 30);
                        ctx.fillText(artist, 980, tempy);
                        totalY += PAD * 3;
                        ctx.drawImage(artwork, 0, totalY, 1275, 876);
                        totalY += PAD * 4 + 876;
                        ctx.fillText('Dear ' + repPrefix + ' ' + repName + ',', PAD, totalY);
                        totalY += PAD * 2;
                        wrapText(ctx, message, PAD, totalY, canvas.width - PAD * 2, 30);
                        totalY += PAD;
                        ctx.fillText('Sincerely,', PAD, totalY);
                        totalY += PAD * 3;
                        ctx.fillText(registered, PAD, totalY + 64);
                        ctx.drawImage(signature, PAD, totalY - PAD * 2, 360, 87.5);
                        ctx.fillText(firstName + ' ' + lastName + '        ' +  date, 450 + PAD, totalY);
                        totalY += PAD * 1.5;
                        wrapText(ctx, address, 450 + PAD, totalY, 700, 30);
                        $rootScope.$broadcast('faxCanvasRendered');
                    });
                }

                $rootScope.$on('createFaxCanvas', draw);
                // draw();
            }
        };
    }])
;

/* global angular */
angular.module('ua5App')
    .directive('faxPage', [function() {
        return {
            restrict: 'A',
            templateUrl: 'components/fax-page/fax-page.html',
            link: function($scope, element, attrs) {}
        };
    }])
;

/* global angular, $, _, SignaturePad, moment, TweenMax, TimelineMax, Linear, JSON, Modernizr */
angular.module('ua5App')
    .directive('fax', ['$rootScope', '$timeout', '$q', '$analytics', function($rootScope, $timeout, $q, $analytics) {
        return {
            restrict: 'A',
            scope: {
                faxArtwork: '=',
                exitFax: '&',
                prevArtwork: '&',
                nextArtwork: '&'
            },
            templateUrl: 'components/fax/fax.html',
            link: function($scope, element, attrs) {
                var $fax,
                    $faxForm,
                    $faxReview,
                    $faxConfirmation,
                    $faxConfirmationPage,
                    $faxConfirmationCta,
                    $faxConfirmationStamp,
                    $faxConfirmationLoader,
                    $faxConfirmationLoaderExclamation1,
                    $faxConfirmationLoaderExclamation2,
                    $faxConfirmationLoaderExclamation3,
                    $zipcodeInput;
                var API_KEY = 'etcS0g3qJY1fcBv9oCy2afxA8M84IA2fULI0Uxnj';
                var ua5faxNumber = '3109432682';
                var stantonFaxNumber = '3103057880';
                var signatureCanvas, signaturePad;
                var representativesRawData;
                var faxCanvasRendered = $q.defer();
                var messageWordLimit = 120;
                var faxConfirmationTimeline,
                    faxConfirmationLoaderTimeline;

                $scope.stepIndex = 0;
                $scope.steps = [
                    {
                        number: 1,
                        name: 'artwork',
                        title: 'Select Your Artwork',
                        continueText: 'Next: Find Your Elected Official'
                    },
                    {
                        number: 2,
                        name: 'zipcode',
                        title: 'Find Your Elected Official',
                        continueText: 'Next: Select Your Elected Official'
                    },
                    {
                        number: 3,
                        name: 'representative',
                        title: 'Select Your Elected Official',
                        continueText: 'Next: Confirm Your Registration Status'
                    },
                    {
                        number: 4,
                        name: 'registration',
                        title: 'Your Registration Status',
                        continueText: 'Next: Write Your Message'
                    },
                    {
                        number: 5,
                        name: 'message',
                        title: 'Write Your Message',
                        continueText: 'Next: Add Your Name & Sign!'
                    },
                    {
                        number: 6,
                        name: 'signature',
                        title: 'Add Your Name & Sign!',
                        continueText: 'Next: Review & Send Your Fax'
                    }
                ];

                $scope.prefilledMessages = [
                    {
                        name: 'Black Lives Matter',
                        title: 'Black Lives Matter',
                        message: 'I am outraged, fed up, in pain and aggrieved. Police are disproportionately overfunded while our communities are crumbling. It’s time that you commit to building a better future for America. Black and brown people live in a constant state of fear. Fear that those paid to keep them safe may, instead, murder them in cold blood without retribution. How we fund and regulate the groups sworn to protect us must change, and it must change in a dramatic way. I’m asking that you step up and pursue justice for those who have been murdered, and that you act swiftly to reform our disgraceful, broken law enforcement system. Do the right thing; America is watching.'
                    },
                    {
                        name: 'Border Separation',
                        title: 'End Border Separations – Reunite Families',
                        message: 'As your constituent, I am writing to urge you to take action in reuniting families separated by the Trump administration’s border policy. The executive order reversing this separation policy, does nothing to address the situation of the thousands of children already separated from their parents. The American Medical Association has spoken out against the physical and emotional trauma a child faces when forcibly separated from their family. Doctors, psychologists, and child advocates have warned that this trauma may have lifelong implications. Thus, I hope that you consider creating legislation that would reunite these children with their family. Thank you.'
                    },
                    {
                        name: 'Supreme Court',
                        title: 'Keep the Courts Fair',
                        message: 'According to Sen. Mitch McConnell, the Senate shouldn\'t vote on a new Supreme Court nominee during an election year. Let\'s make sure he follows his own rule.\n' +
                        'Trump is the subject of a criminal investigation that could eventually come before the Supreme Court—he has a clear conflict of interest as it relates to picking a new #SCOTUS justice. The investigation must conclude before considering any nominations. Thus, I hope that you will do anything in your power to ensure no justices are confirmed until after November and after the investigation has concluded.'
                    },
                    {
                        name: 'Gun Violence Prevention',
                        title: 'End Gun Violence – Pass Common Sense Laws',
                        message: 'As your constituent, I am deeply concerned about gun violence in our country. I am writing to urge you to take action in passing strict gun control laws. \n' +
                        '\n' +
                        'I need you to take action to ensure:\n' +
                        '- Background checks are be required for every gun owner — including removing gun show loopholes, the Charleston loophole, and family gun transfers\n' +
                        '- That assault weapons and high-capacity firearms are illegal\n' +
                        '- Gun trafficking becomes a federal offense\n' +
                        '\n' +
                        'Thus, I hope that you will consider enacting these common-sense measures to reduce gun violence.\n'
                    },
                    {
                        name: 'The National Endowment for the Arts',
                        title: 'Protect the Arts — Save the NEA!',
                        message: 'As your constituent, I am writing to urge you to defend the National Endowment for the Arts. The NEA does the important work of making the arts accessible to communities from every state and territory. I believe that everyone deserves an opportunity to experience the arts. This opportunity comes at a low cost, compared with the rest of the budget–the NEA only figured for 0.004 percent of federal spending in 2016. Thus, I hope that you will consider defending the NEA from its proposed elimination in the Trump Administration Budget. Thank you.'
                    },
                    {
                        name: 'Custom',
                        title: '',
                        message: ''
                    }
                ];

                function reset() {
                    $scope.autocomplete = new google.maps.places.Autocomplete(
                        document.querySelector('#address')
                    );
                    $scope.stepIndex = 0;
                    $scope.formStep = $scope.steps[$scope.stepIndex];
                    $scope.stepValid = true;
                    $scope.stage = 'entering-info';
                    $scope.zipcode = null;
                    $scope.validZip = true;
                    $scope.selectedRepresentative = null;
                    $scope.representatives = [];
                    $scope.registered = undefined;
                    $scope.message = '';
                    $scope.title = '';
                    $scope.selectedItem = 'Custom';
                    $scope.messageWordCount = 0;
                    $scope.name = {
                        first: null,
                        last: null
                    };
                    $scope.date = moment().format('ll');
                    $scope.signatureImage = null;
                    $scope.returningToForm = false;
                    $scope.agreed = false;
                    if (signatureCanvas && signaturePad) {
                        resizeCanvas();
                    }
                    if ($faxReview) {
                        TweenMax.set($faxReview, {y: '100%', scrollTo: {y: 0}});
                    }
                }

                reset();

                $scope.changeStep = function(forwards) {
                    $scope.stepValid = false;
                    $scope.returningToForm = false;

                    if (forwards && $scope.stepIndex < $scope.steps.length - 1) {
                        if ($scope.stepIndex === 1) {
                            $scope.selectedRepresentative = null;
                            $scope.address = '';
                            if ($scope.autocomplete.getPlace() && $scope.autocomplete.getPlace().formatted_address) {
                                $scope.address = $scope.autocomplete.getPlace().formatted_address;
                                getRepresentatives($scope.address, function () {
                                    $scope.formStep = $scope.steps[$scope.stepIndex];
                                    $scope.$apply();
                                });
                                $scope.stepValid = true;
                                $scope.stepIndex++;
                                $scope.stepValid = false;
                            } else {
                                $scope.stepValid = false;
                                $scope.validZip = false;
                            }
                        } else {
                            $scope.stepIndex++;
                        }
                    } else if (!forwards && $scope.stepIndex > 0) {
                        $scope.stepIndex--;

                        if ($scope.stepIndex === 1) {
                            $scope.selectedRepresentative = null;
                            $scope.representatives = [];
                            $scope.formStep = $scope.steps[$scope.stepIndex];
                            $timeout(function() {
                                $zipcodeInput.focus();
                            }, 200);
                            return;
                        } else if ($scope.stepIndex === 2) {
                            if ($scope.selectedRepresentative) {
                                $scope.stepValid = true;
                            }
                        }
                    } else if ($scope.stepIndex === $scope.steps.length - 1) {
                        $scope.stepValid = true;
                        $scope.returningToForm = true;
                        $scope.signatureImage = signaturePad.toDataURL();
                        $scope.date = moment().format('ll');
                        $scope.stage = 'finalizing';
                        TweenMax.set($faxReview, {scrollTo: {y: 0}});
                        TweenMax.fromTo($faxReview, 1, {y: '100%'}, {y: '0%', ease: Linear.easeNone, delay: 1});
                        return;
                    }

                    if ($scope.stepIndex === 0) {
                        $rootScope.selectingArtwork = true;
                        $scope.stepValid = true;
                    } else if ($scope.stepIndex === 1) {
                        //focus zipcode field
                        $('[data-auto-focus]').focus();
                    } else if ($scope.stepIndex === 3) {
                        if ($scope.registered !== undefined) {
                            $scope.stepValid = true;
                        }
                    } else if ($scope.stepIndex === 4) {
                        if ($scope.message) {
                            $scope.stepValid = true;
                        }
                    } else if ($scope.stepIndex === 5) {
                        $timeout(resizeCanvas, 200);
                        if ($scope.name.first && $scope.name.last && $scope.signatureImage) {
                            $scope.stepValid = true;
                        }
                    }

                    if ($scope.stepIndex > 0) {
                        $rootScope.selectingArtwork = false;
                    }

                    $scope.stage = 'entering-info';
                    $scope.formStep = $scope.steps[$scope.stepIndex];
                };

                $scope.returnToForm = function() {
                    $scope.stage = 'signing';
                    TweenMax.set($faxReview, {scrollTo: {y: 'max'}});
                    TweenMax.to($faxReview, 1, {y: '-100%', ease: Linear.easeNone});
                    $timeout(resizeCanvas, 200);
                };

                $scope.agreeToTerms = function() {
                    $scope.agreed = !$scope.agreed;
                };

                $rootScope.$on('faxCanvasRendered', function() {
                    faxCanvasRendered.resolve();
                });

                function generateAndSendFax() {
                    var canvas = $('#fax-canvas')[0];
                    var faxImage;
                    var faxNumber = (window.location.hostname === ('artifax.us')) ? $scope.selectedRepresentative.fax : stantonFaxNumber;
                    var sentTimeline = new TimelineMax({paused: true, onComplete: function() {
                        faxConfirmationTimeline.restart();
                    }});
                    //comment this this:
                    $rootScope.$broadcast('createFaxCanvas');
                    sentTimeline
                        .to([$faxConfirmationLoaderExclamation1, $faxConfirmationLoaderExclamation2, $faxConfirmationLoaderExclamation3], 0.2, {opacity: 1})
                        .to($faxConfirmationLoader, 0.2, {opacity: 0});
                    faxCanvasRendered.promise.then(function() {
                        faxCanvasRendered = $q.defer();
                        faxImage = canvas.toDataURL();
                        faxImage = faxImage.slice(22);
                        $.ajax('https://9v8s5kzn7d.execute-api.us-west-1.amazonaws.com/test/artifax/', {
                            type: 'POST',
                            data: JSON.stringify({
                                to: faxNumber,
                                data: faxImage
                            }),
                            success: function() {
                                faxConfirmationLoaderTimeline.pause();
                                sentTimeline.restart();
                            }
                        });
                        $analytics.eventTrack('submitted', {
                            category: 'title', label: $scope.title
                        });
                    });
                }

                $scope.submitFax = function() {
                    $scope.time = moment().format('h:mmA');
                    $scope.stage = 'confirming';
                    TweenMax.set($faxReview, {scrollTo: {y: 'max'}});
                    TweenMax.to($faxReview, 1.5, {y: '-100%', onComplete: function() {
                        TweenMax.set($faxConfirmationLoader, {opacity: 1});
                        faxConfirmationLoaderTimeline.restart();
                        generateAndSendFax();
                    }});
                };

                $scope.selectPrefilled = function(e) {
                    var prefilled = $scope.prefilledMessages[$scope.selectedItem];
                    $scope.message = prefilled.message;
                    $scope.title = prefilled.title;
                    $scope.countMessageWords();
                };

                $scope.setRepresentative = function(representative) {
                    if ($scope.selectedRepresentative === representative) {
                        $scope.selectedRepresentative = null;
                        $scope.stepValid = false;
                    } else {
                        $scope.selectedRepresentative = representative;
                        $scope.stepValid = true;
                        TweenMax.to('.fax__form__step.representative', 0.5, {scrollTo: {y: 'max'}});
                    }
                };

                $scope.setRegistration = function(registered) {
                    $scope.registered = registered;
                    $scope.stepValid = true;
                    TweenMax.to('.fax__form__step.registration', 0.5, {scrollTo: {y: 'max'}});
                };

                $scope.prefillMessage = function() {
                    $scope.message = 'As your constituent, I am writing to urge you to defend the National Endowment for the Arts. The NEA does the important work of making the arts accessible to communities from every state and territory. I believe that everyone deserves an opportunity to experience the arts. This opportunity comes at a low cost, compared with the rest of the budget–the NEA only figured for 0.004 percent of federal spending in 2016. Thus, I hope that you will consider defending the NEA from its proposed elimination in the Trump Administration Budget. Thank you.';
                    $scope.countMessageWords();
                    TweenMax.to('.fax__form__step.message', 0.5, {scrollTo: {y: 'max'}});
                };

                $scope.clearMessage = function() {
                    $scope.message = '';
                    $scope.title = '';
                    $scope.countMessageWords();
                };

                $scope.countMessageWords = function(e) {
                    var words = _.reject($scope.message.split(/\s+/), function(word) {
                        return !word.length;
                    });

                    $scope.messageWordCount = words.length;
                    if ($scope.messageWordCount >= messageWordLimit) {
                        $scope.wordLimitReached = true;

                        if (e.which === 9 || e.which === 13 || e.which === 32) {
                            e.preventDefault();
                        }
                    } else if ($scope.wordLimitReached) {
                        $scope.wordLimitReached = false;
                    }

                    if ($scope.message) {
                        $scope.stepValid = true;
                    } else {
                        $scope.stepValid = false;
                    }
                };

                function getRepresentatives(zipcode, callback) {
                    var url = 'https://www.googleapis.com/civicinfo/v2/representatives?address=' + zipcode;
                    url += '&levels=administrativeArea1&levels=country&levels=locality&key=AIzaSyCv5BuW9Az43nDG26snoyEkpjROc-0d7WQ';
                    $.get({ url: url }, function(data) {
                        var reps = [];
                        _.each(data.offices, function(office) {
                            if (
                                office.name !== 'President of the United States' &&
                                office.name !== 'Vice-President of the United States' &&
                                office.name !== 'Lieutenant Governor' &&
                                office.name !== 'Governor'
                            ) {
                                _.each(office.officialIndices, function(repId) {
                                    var rep = data.officials[repId];
                                    var faxInfo = _.findWhere($rootScope.LEGISLATORS, {name: rep.name });
                                    if (faxInfo) {
                                        rep.fax = faxInfo.fax;
                                        rep.office = office;
                                        reps.push(rep);
                                    }
                                });
                            }
                        });
                        representativesRawData = reps;
                        if (!representativesRawData || representativesRawData.length < 1) {
                            $scope.stepIndex = 1;
                            $scope.validZip = false;
                            $scope.$apply();
                            return;
                        } else {
                            $scope.validZip = true;
                            $scope.$apply();
                        }
                        $scope.representatives = _.map(representativesRawData, function(rep) {
                            var photoUrl = '';
                            if (rep.photoUrl && rep.photoUrl.indexOf('https://') > -1) {
                                photoUrl = rep.photoUrl;
                            } else if (rep.photoUrl && rep.photoUrl.indexOf('http://bioguide.congress.gov') > -1) {
                                photoUrl = rep.photoUrl.replace('http://bioguide.congress.gov', 'https://d116m5omwy40mk.cloudfront.net');
                            } else {
                                photoUrl = 'assets/images/no-picture.svg'
                            }
                            return {
                                image: photoUrl,
                                name: rep.name,
                                title: rep.office.name,
                                prefix: '',
                                fax: rep.fax
                            };
                        });
                        callback();
                    });
                }

                $scope.checkFullName = function() {
                    if ($scope.name.first && $scope.name.last && $scope.signatureDrawn) {
                        $scope.stepValid = true;
                    } else {
                        $scope.stepValid = false;
                    }
                };

                function beginSignature() {
                    $scope.signatureDrawn = true;
                    $scope.$apply();
                }

                function handleSignature() {
                    if (!signaturePad.isEmpty()) {
                        $scope.signatureImage = signaturePad.toDataURL();
                    } else {
                        $scope.signatureDrawn = false;
                        $scope.signatureImage = null;
                    }

                    if ($scope.name.first && $scope.name.last && $scope.signatureDrawn) {
                        $scope.stepValid = true;
                    } else {
                        $scope.stepValid = false;
                    }

                    $scope.$apply();
                }
                $scope.faxAddressFocus = function() {
                    $zipcodeInput.attr('autocomplete', 'new-password');
                }

                $scope.download = function(event) {
                    var imageData;
                    var strDataURI;
                    var blob;
                    var objurl;
                    function dataURLtoBlob(dataurl) {
                        var arr = dataurl.split(','), mime = arr[0].match(/:(.*?);/)[1],
                            bstr = atob(arr[1]), n = bstr.length, u8arr = new Uint8Array(n);
                        while (n--) {
                            u8arr[n] = bstr.charCodeAt(n);
                        }
                        return new Blob([u8arr], {type:mime});
                    }
                    imageData = document.getElementById('fax-canvas').toDataURL({format:'png', multiplier: 4});
                    event.target.download = 'Artifax-' + $scope.selectedRepresentative.name.replace(/ /g, '') + '-' + $scope.title.replace(/ /g, '') + '.png';
                    strDataURI = imageData.substr(22, imageData.length);
                    blob = dataURLtoBlob(imageData);
                    objurl = URL.createObjectURL(blob);
                    event.target.href = objurl;
                };

                $scope.clearSignature = function() {
                    signaturePad.clear();
                    $scope.signatureImage = null;
                    $scope.signatureDrawn = false;
                    $scope.stepValid = false;
                };

                function resizeCanvas() {
                    var ratio =  Math.max(window.devicePixelRatio || 1, 1);
                    signatureCanvas.width = signatureCanvas.offsetWidth * ratio;
                    signatureCanvas.height = signatureCanvas.offsetHeight * ratio;
                    signatureCanvas.getContext('2d').scale(ratio, ratio);
                    signaturePad.clear();
                    if ($scope.signatureImage) {
                        signaturePad.fromDataURL($scope.signatureImage);
                    }
                }

                function resetConfirmation() {
                    if (!$faxConfirmationStamp.length || !$faxConfirmationPage.length || !$faxConfirmationCta.length) {
                        $faxConfirmationPage = $('.fax__confirmation__page');
                        $faxConfirmationCta = $('.fax__confirmation__cta');
                        $faxConfirmationStamp = (Modernizr.touch && window.innerWidth < 900) ? $('.fax__confirmation__stamp--mobile') : $('.fax__confirmation__stamp');
                    }
                    TweenMax.set($faxConfirmationStamp, {autoAlpha: 0, scale: 2, z: 100});
                    TweenMax.set($faxConfirmationPage, {autoAlpha: 0});
                    TweenMax.set($faxConfirmationCta, {autoAlpha: 0});
                }

                function init() {
                    $fax = $(element).find('.fax');
                    $faxForm = $fax.find('.fax__form');
                    $faxReview = $fax.find('.fax__review');
                    $faxConfirmation = $fax.find('.fax__confirmation');
                    $faxConfirmationPage = $faxConfirmation.find('.fax__confirmation__page');
                    $faxConfirmationCta = $faxConfirmation.find('.fax__confirmation__cta');
                    $faxConfirmationStamp = (Modernizr.touch && window.innerWidth < 900) ? $faxConfirmation.find('.fax__confirmation__stamp--mobile') : $faxConfirmation.find('.fax__confirmation__stamp');
                    $faxConfirmationLoader = $faxConfirmation.find('.fax__confirmation__loader');
                    $faxConfirmationLoaderExclamation1 = $faxConfirmationLoader.find('.one');
                    $faxConfirmationLoaderExclamation2 = $faxConfirmationLoader.find('.two');
                    $faxConfirmationLoaderExclamation3 = $faxConfirmationLoader.find('.three');
                    $zipcodeInput = $fax.find('.fax__form__zipcode__input');
                    signatureCanvas = $fax.find('.fax__form__signature__pad')[0];
                    signaturePad = new SignaturePad(signatureCanvas, {
                        onBegin: beginSignature,
                        onEnd: handleSignature
                    });
                    window.addEventListener('resize', resizeCanvas);
                    reset();
                    resetConfirmation();

                    faxConfirmationTimeline = new TimelineMax({paused: true});
                    faxConfirmationTimeline
                        .set($faxConfirmation, {display: 'block'})
                        .to($faxConfirmationStamp, 0.5, {autoAlpha: 1, scale: 1, z: 0})
                        .to($faxConfirmationPage, 0.5, {autoAlpha: 1}, '+=1')
                        .to($faxConfirmationCta, 0.5, {autoAlpha: 1}, '+=1');

                    if (!Modernizr.touch || window.innerWidth >= 900) {
                        faxConfirmationTimeline
                            .set($faxConfirmationStamp, {display: 'none'})
                            .to($faxConfirmationStamp, 0.5, {autoAlpha: 0});
                    }

                    faxConfirmationLoaderTimeline = new TimelineMax({paused: true});
                    faxConfirmationLoaderTimeline
                        .to($faxConfirmationLoaderExclamation1, 0.2, {opacity: 1})
                        .to($faxConfirmationLoaderExclamation2, 0.2, {opacity: 1})
                        .to($faxConfirmationLoaderExclamation3, 0.2, {opacity: 1});

                    $rootScope.$watch('preparingFax', function(n, o) {
                        if (n === false) {
                            reset();
                            resetConfirmation();
                        }
                    });
                }

                $timeout(init);
            }
        };
    }])
;

/* global angular, TweenMax, $ */
angular.module('ua5App')
    .directive('footer', [function() {
        return {
            restrict: 'A',
            templateUrl: 'components/footer/footer.html',
            link: function($scope, element, attrs) {
                var $text;

                $text = $('.footer__company__text', $(element));

                $scope.showText = function() {
                    TweenMax.to($text, 0.4, {
                        left: 0,
                        opacity: 1
                    });
                };

                $scope.hideText = function() {
                    TweenMax.to($text, 0.4, {
                        left: 40,
                        opacity: 0
                    });
                };
            }
        };
    }])
;

/* global angular, $, TweenMax, TimelineMax */
angular.module('ua5App')
    .directive('intro', ['$rootScope', '$timeout', '$q', function($rootScope, $timeout, $q) {
        return {
            restrict: 'A',
            templateUrl: 'components/intro/intro.html',
            link: function($scope, element, attrs) {
                var $element = $(element);
                var $exclamation1, $exclamation2, $exclamation3;
                var exclamationTimeline;
                var d1;
                var d2;
                var d3;

                d1 = $q.defer();
                d2 = $q.defer();
                d3 = $q.defer();

                $scope.hideIntro = false;

                function init() {
                    $(window).on('beforeunload', function() {
                        $(window).scrollTop(0);
                    });
                    $q.all([d1.promise, d2.promise, d3.promise]).then(function() {
                        $timeout(function() {
                            animateExclamations();
                            exclamationTimeline.restart();
                        }, 1000);
                    });
                }

                function animateExclamations() {
                    $exclamation1 = $element.find('.intro__exclamation.one');
                    $exclamation2 = $element.find('.intro__exclamation.two');
                    $exclamation3 = $element.find('.intro__exclamation.three');
                    exclamationTimeline = new TimelineMax({paused: true});
                    exclamationTimeline.set($exclamation1, {opacity: 1})
                        .from($exclamation1, 0.2, {scale: 0.5, z: -5000})
                        .set($exclamation2, {opacity: 1})
                        .from($exclamation2, 0.2, {scale: 0.5, z: -5000})
                        .set($exclamation3, {opacity: 1})
                        .from($exclamation3, 0.2, {scale: 0.5, z: -5000, onComplete: function() {
                            $timeout(dismiss, 500);
                        }})
                    ;
                }

                function dismiss() {
                    $element.off();
                    $rootScope.introDismissed = true;
                    $rootScope.$applyAsync();
                    $timeout(function() {
                        $scope.hideIntro = true;
                    }, 1000);
                }

                $timeout(init);

                $scope.finishedLoading1 = function() {
                    d1.resolve();
                }

                $scope.finishedLoading2 = function() {
                    d2.resolve();
                }

                $scope.finishedLoading3 = function() {
                    d3.resolve();
                }
            }
        };
    }])
;

/* global angular, $ */
angular.module('ua5App')
    .directive('logo', ['$timeout', 'BREAKPOINTS', function($timeout, BREAKPOINTS) {
        return {
            restrict: 'A',
            templateUrl: 'components/logo/logo.html',
            link: function($scope, element, attrs) {

            }
        };
    }])
;

/* global angular */
angular.module('ua5App')
    .directive('nav', [function() {
        return {
            restrict: 'A',
            templateUrl: 'components/nav/nav.html',
            link: function($scope, element, attrs) {
                $scope.mobileNavOpen = false;

                $scope.toggleMobileNav = function() {
                    $scope.mobileNavOpen = !$scope.mobileNavOpen;
                };
            }
        };
    }])
;

/* global angular, ScrollReveal */
angular.module('ua5App')
    .directive('scrollReveal', ['$timeout', function($timeout) {
        return {
            restrict: 'A',
            scope: {
                scrollRevealSettings: '='
            },
            link: function($scope, element, attrs) {
                $timeout(function() {
                    if (!window.scrollReveal) {
                        window.scrollReveal = new ScrollReveal();
                    }
                    window.scrollReveal.reveal(element, $scope.scrollRevealSettings);
                }, 0);
            }
        };
    }])
;

/* global angular */
angular.module('ua5App')
    .directive('shareE', ['$location', function($location) {
        return {
            restrict: 'A',
            scope: {
                shareEBody: '@',
                shareESubject: '@'
            },
            link: function($scope, element, attrs) {
                var body;
                var subject;
                body = $scope.shareEBody || $location.absUrl();
                subject = $scope.shareESubject || $location.absUrl();
                element[0].href = 'mailto:?subject=' + subject + '&body=' + body;
                element[0].target = '_blank';
            }
        };
    }])
;

/* global angular */
angular.module('ua5App')
    .directive('shareFb', ['popup', '$location', function(popup, $location) {
        return {
            restrict: 'A',
            scope: {
                shareFbUrl: '@'
            },
            link: function($scope, element, attrs) {
                var url;
                var fbUrl;
                url = $scope.shareFbUrl || $location.absUrl();
                fbUrl = 'https://www.facebook.com/sharer.php?u=' + encodeURIComponent(url);
                element.on('click', function() {
                    popup.show(fbUrl);
                });
                $scope.$on('$destroy', function() {
                    element.off('click');
                });
            }
        };
    }])
;

/* global angular */
angular.module('ua5App')
    .directive('shareTw', ['popup', '$location', function(popup, $location) {
        return {
            restrict: 'A',
            scope: {
                shareTwUrl: '@',
                shareTwText: '@'
            },
            link: function($scope, element, attrs) {
                var text;
                var twUrl;
                var url;
                url = $scope.shareTwUrl || $location.absUrl();
                text = encodeURIComponent($scope.shareTwText || '');
                twUrl = 'https://twitter.com/intent/tweet?text=' + text + '&url=' + url;
                element.on('click', function() {
                    popup.show(twUrl, 600, 253);
                });
                $scope.$on('$destroy', function() {
                    element.off('click');
                });
            }
        };
    }])
;

/* global angular, $, TweenMax, Linear */
angular.module('ua5App')
    .directive('ticker', ['$rootScope', '$timeout', function($rootScope, $timeout) {
        return {
            restrict: 'A',
            templateUrl: 'components/ticker/ticker.html',
            link: function($scope, element, attrs) {
                var $element,
                    $tickerInner,
                    $messages,
                    tickerRunning = false;

                var messagesWidth,
                    tickerTween;

                $scope.messages = [
                    '<a target="_blank" href="https://www.washingtonpost.com/business/economy/trump-federal-budget-2018-massive-cuts-to-the-arts-science-and-the-poor/2017/03/15/0a0a0094-09a1-11e7-a15f-a58d4a988474_story.html?utm_term=.f9882c453ec8">Trump Federal Budget 2018: Massive Cuts to the Arts, Science and the Poor</a>',
                    '<a target="_blank" href="https://www.nytimes.com/2017/01/30/arts/design/donald-trump-arts-humanities-public-television.html?_r=1">What if Trump Really Does End Money for the Arts?</a>',
                    '<a target="_blank" href="https://www.good.is/articles/why-government-wants-to-cut-national-endowment-arts-nea">Cutting Public Funds For The Arts Could Cost America Billions</a>'
                ];

                function init() {
                    $element = $(element);
                    $tickerInner = $(element).find('.ticker__inner');
                    $messages = $element.find('.ticker__messages');
                    $messages.clone().appendTo($tickerInner);
                    messagesWidth = $messages.width();

                    tickerTween = TweenMax.to($tickerInner, (messagesWidth / 50), {
                        x: -messagesWidth,
                        ease: Linear.easeNone,
                        repeat: -1
                    }).timeScale(0);

                    $element.hover(function() {
                        TweenMax.to(tickerTween, 1, {timeScale: 0});
                    }, function() {
                        TweenMax.killTweensOf(tickerTween);
                        TweenMax.set(tickerTween, {timeScale: 4});
                    });

                    $element.bind('touchend mouseout', function() {
                        if (!tickerRunning) {
                            TweenMax.killTweensOf(tickerTween);
                            TweenMax.set(tickerTween, {timeScale: 4});
                            tickerRunning = true;
                        }
                    }).bind('touchstart mouseover', function() {
                        if (tickerRunning) {
                            TweenMax.to(tickerTween, 1, {timeScale: 0});
                            tickerRunning = false;
                        }
                    });
                }

                $rootScope.$watch('introDismissed', function(n, o) {
                    if (n) {
                        tickerTween.timeScale(4);
                        tickerRunning = true;
                    }
                });

                $timeout(init);
            }
        };
    }])
;

/* global angular, _, $ */
angular.module('ua5App')
    .directive('unorphanize', [function() {
        return {
            restrict: 'A',
            scope: {
                unorphanize: '@'
            },
            link: function($scope, element, attrs) {
                var n;
                n = parseInt($scope.unorphanize, 10) || 1;
                _.defer(function() {
                    $(element).unorphanize(n);
                });
            }
        };
    }])
;

/* global angular */
angular.module('ua5App')
    .factory('ArtworksFactory', ['$resource', '$rootScope', '$q', function($resource, $rootScope, $q) {
        var apiPath = 'data/artworks.json?v=2';
        var d = $q.defer();
        var initialized;

        return {
            get: function() {
                if (!initialized) {
                    initialized = true;
                    $resource(apiPath, {},
                        {
                            retrieve: {method: 'GET'}
                        }
                    ).retrieve(function(data) {
                        d.resolve(data.artworks);
                    });
                }
                return d.promise;
            }
        };
    }])
;

/* global angular, Modernizr */
angular.module('ua5App')
    .factory('BrowserFactory', [function() {
        var isChrome;
        var isExplorer;
        var isFirefox;
        var isSafari;
        var isOpera;
        var isAndroid;
        var isEdge;
        var isWkWebView = false;
        var isMobile = false;
        var isIframe = false;
        isChrome = navigator.userAgent.indexOf('Chrome') > -1;
        isExplorer = navigator.userAgent.indexOf('MSIE') > -1 || navigator.userAgent.indexOf('Trident') > -1;
        isFirefox = navigator.userAgent.indexOf('Firefox') > -1;
        isSafari = navigator.userAgent.indexOf('Safari') > -1;
        isOpera = navigator.userAgent.toLowerCase().indexOf('op') > -1;
        isAndroid = navigator.userAgent.toLowerCase().indexOf('android') > -1;
        isEdge = navigator.userAgent.toLowerCase().indexOf('edge') > -1;
        // Chrome has both 'Chrome' and 'Safari' inside userAgent string.
        if ((isChrome) && (isSafari)) {
            isSafari = false;
        }
        if ((isChrome) && (isOpera)) {
            isChrome = false;
        }
        if ((isChrome) && (isEdge)) {
            isChrome = false;
        }
        if (navigator.platform.substr(0, 2) === 'iP') {
            //iOS (iPhone, iPod or iPad)
            var lte9 = /constructor/i.test(window.HTMLElement);
            var nav = window.navigator, ua = nav.userAgent, idb = !!window.indexedDB;

            if (ua.indexOf('Safari') !== -1 && ua.indexOf('Version') !== -1 && !nav.standalone) {
                //Safari (WKWebView/Nitro since 6+)
            } else if ((!idb && lte9) || !window.statusbar.visible) {
                //UIWebView
            } else if ((window.webkit && window.webkit.messageHandlers) || !lte9 || idb) {
                //WKWebView
                isWkWebView = true;
            }
        }
        // device detection
        if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|ipad|iris|kindle|Android|Silk|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(navigator.userAgent)
            || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(navigator.userAgent.substr(0,4))) {
            isMobile = true;
        }

        if (window.self !== window.top) {
            isIframe = true;
        } else {
            isIframe = false;
        }

        return {
            isSafari: function() {
                return isSafari;
            },
            isChrome: function() {
                return isChrome;
            },
            isFirefox: function() {
                return isFirefox;
            },
            isExplorer: function() {
                return isExplorer;
            },
            isEdge: function() {
                return isEdge;
            },
            isFastBrowser: function() {
                return ((isChrome || isFirefox) && !Modernizr.touch);
            },
            hasTouch: function() {
                return Modernizr.touch;
            },
            hasWebGl: function() {
                return Modernizr.webgl;
            },
            isAndroid: function() {
                return isAndroid;
            },
            isWkWebView: function() {
                return isWkWebView;
            },
            isMobile: function() {
                return isMobile;
            },
            isIframe: function() {
                return isIframe;
            }
        };
    }])
;

/* global angular */
angular.module('ua5App')
    .factory('LegislatorsFactory', ['$resource', '$rootScope', '$q', function($resource, $rootScope, $q) {
        // From https://github.com/unitedstates/congress-legislators
        var file = 'data/legislators/legislators-current-06-01-2020.json';
        var d = $q.defer();
        var initialized;

        // Congress Member Directory ↴
        // https://www.congressweb.com/
        var missingCongressman = [
            {'first_name':'Mike','last_name':'Lee','fax':'2022281168'},
            {'first_name':'Tom','last_name':'Cotton','fax':'4799271092'},
            {'first_name':'Eric','last_name':'Swalwell','fax':'9254605320'},
            {'first_name':'Ted','last_name':'Yoho','fax':'9254605320'},
            {'first_name':'Tammy','last_name':'Duckworth','fax':'2022280618'},
            {'first_name':'Garland','last_name':'Barr','fax':'2022252122'},
            {'first_name':'Hakeem','last_name':'Jeffries','fax':'2022251018'},
            {'first_name':'Derek','last_name':'Kilmer','fax':'2022263575'},
            {'first_name':'Bruce','last_name':'Westerman','fax':'2022251314'},
            {'first_name':'Ruben','last_name':'Gallego','fax':'6022579103'},
            {'first_name':'Will','last_name':'Hurd','fax':'2022252237'},
            {'first_name':'Dan','last_name':'Sullivan','fax':'2022246501'},
            {'first_name':'David','last_name':'Perdue','fax':'2022240103'},
            {'first_name':'Joni','last_name':'Ernst','fax':'2022249369'},
            {'first_name':'Thom','last_name':'Tillis','fax':'2022282563'},
            {'first_name':'Mike','last_name':'Rounds','fax':'2022247482'},
            {'first_name':'Benjamin','last_name':'Sasse','fax':'2022280436'},
            {'first_name':'Trent','last_name':'Kelly','fax':'2022253549'},
            {'first_name':'Darin','last_name':'LaHood','fax':'2022259249'},
            {'first_name':'Warren','last_name':'Davidson','fax':'2022250704'},
            {'first_name':'James','last_name':'Comer','fax':'5025646543'},
            {'first_name':'Dwight','last_name':'Evans','fax':'2152762939'},
            {'first_name':'Kamala','last_name':'Harris','fax':'2022242200'},
            {'first_name':'John','last_name':'Kennedy','fax':'2022280447'},
            {'first_name':'Margaret','last_name':'Hassan','fax':'2022244952'},
            {'first_name':'Catherine','last_name':'Cortez Masto','fax':'2022247327'},
            {'first_name':'Tom','last_name':'O’Halleran','fax':'2022253462'},
            {'first_name':'Andy','last_name':'Biggs','fax':'2022264386'},
            {'first_name':'Ro','last_name':'Khanna','fax':'2022252699'},
            {'first_name':'Jimmy','last_name':'Panetta','fax':'2022256791'},
            {'first_name':'Salud','last_name':'Carbajal','fax':'2022255632'},
            {'first_name':'Nanette','last_name':'Barragán','fax':'2022267290'},
            {'first_name':'J.','last_name':'Correa','fax':'2022255859'},
            {'first_name':'Lisa','last_name':'Blunt Rochester','fax':'2022252291'},
            {'first_name':'Matt','last_name':'Gaetz','fax':'2022253414'},
            {'first_name':'Neal','last_name':'Dunn','fax':'2022255615'},
            {'first_name':'John','last_name':'Rutherford','fax':'2022252504'},
            {'first_name':'Al','last_name':'Lawson','fax':'2022252256'},
            {'first_name':'Stephanie','last_name':'Murphy','fax':'2022260821'},
            {'first_name':'Darren','last_name':'Soto','fax':'2022259742'},
            {'first_name':'Val','last_name':'Demings','fax':'2022250999'},
            {'first_name':'Charlie','last_name':'Crist','fax':'2022259764'},
            {'first_name':'Brian','last_name':'Mast','fax':'2022258398'},
            {'first_name':'A.','last_name':'Ferguson','fax':'2022252515'},
            {'first_name':'Raja','last_name':'Krishnamoorthi','fax':'2022257830'},
            {'first_name':'Jim','last_name':'Banks','fax':'2022269870'},
            {'first_name':'Trey','last_name':'Hollingsworth','fax':'2022266866'},
            {'first_name':'Roger','last_name':'Marshall','fax':'2022255124'},
            {'first_name':'Clay','last_name':'Higgins','fax':'2022255724'},
            {'first_name':'Mike','last_name':'Johnson','fax':'2022258039'},
            {'first_name':'Anthony','last_name':'Brown','fax':'2022258714'},
            {'first_name':'Jamie','last_name':'Raskin','fax':'4108413850'},
            {'first_name':'Jack','last_name':'Bergman','fax':'2022254710'},
            {'first_name':'Paul','last_name':'Mitchell','fax':'2022261169'},
            {'first_name':'Ted','last_name':'Budd','fax':'2022255662'},
            {'first_name':'Don','last_name':'Bacon','fax':'2022265452'},
            {'first_name':'Josh','last_name':'Gottheimer','fax':'2022259048'},
            {'first_name':'Jacky','last_name':'Rosen','fax':'2022252185'},
            {'first_name':'Brian','last_name':'Fitzpatrick','fax':'2022259511'},
            {'first_name':'Lloyd','last_name':'Smucker','fax':'2022252013'},
            {'first_name':'Jenniffer','last_name':'González-Colón','fax':'2022252154'},
            {'first_name':'David','last_name':'Kustoff','fax':'2022251765'},
            {'first_name':'Vicente','last_name':'Gonzalez','fax':'2022255688'},
            {'first_name':'Jodey','last_name':'Arrington','fax':'2022259615'},
            {'first_name':'A.','last_name':'McEachin','fax':'2022261170'},
            {'first_name':'Pramila','last_name':'Jayapal','fax':'2022256197'},
            {'first_name':'Mike','last_name':'Gallagher','fax':'2022255729'},
            {'first_name':'Liz','last_name':'Cheney','fax':'2022253057'},
            {'first_name':'Ron','last_name':'Estes','fax':'2022253489'},
            {'first_name':'Ralph','last_name':'Norman','fax':'2022250464'},
            {'first_name':'Jimmy','last_name':'Gomez','fax':'2134811427'},
            {'first_name':'John','last_name':'Curtis','fax':'2022255629'},
            {'first_name':'Doug','last_name':'Jones','fax':'2022243149'},
            {'first_name':'Tina','last_name':'Smith','fax':'2022240044'},
            {'first_name':'Cindy','last_name':'Hyde-Smith','fax':'2022245321'},
            {'first_name':'Conor','last_name':'Lamb','fax':'2022251844'},
            {'first_name':'Debbie','last_name':'Lesko','fax':'6237767832'},
            {'first_name':'Michael','last_name':'Cloud','fax':'2022261134'},
            {'first_name':'Troy','last_name':'Balderson','fax':'2022264523'},
            {'first_name':'Kevin','last_name':'Hern','fax':'2022259187'},
            {'first_name':'Joseph','last_name':'Morelle','fax':'5852321954'},
            {'first_name':'Mary','last_name':'Scanlon','fax':'6106262380'},
            {'first_name':'Susan','last_name':'Wild','fax':'8773474103'},
            {'first_name':'Ed','last_name':'Case','fax':'2022250688'},
            {'first_name':'Steven','last_name':'Horsford','fax':'2022259783'},
            {'first_name':'Greg','last_name':'Stanton','fax':'2022259731'},
            {'first_name':'Josh','last_name':'Harder','fax':'2022253402'},
            {'first_name':'TJ','last_name':'Cox','fax':'8332849090'},
            {'first_name':'Gilbert','last_name':'Cisneros','fax':'2022250335'},
            {'first_name':'Katie','last_name':'Porter','fax':'2022259177'},
            {'first_name':'Harley','last_name':'Rouda','fax':'2022262263'},
            {'first_name':'Mike','last_name':'Levin','fax':'2022253303'},
            {'first_name':'Joe','last_name':'Neguse','fax':'2022267840'},
            {'first_name': 'Jason', 'last_name': 'Crow', 'fax': '2022264623'},
            {'first_name':'Jahana','last_name':'Hayes','fax':'8602257289'},
            {'first_name':'Michael','last_name':'Waltz','fax':'3862835164'},
            {'first_name':'Ross','last_name':'Spano','fax':'2022260585'},
            {'first_name':'W.','last_name':'Stuebe','fax':'2022253132'},
            {'first_name':'Debbie','last_name':'Mucarsel-Powell','fax':'2022260346'},
            {'first_name':'Donna','last_name':'Shalala','fax':'2022255620'},
            {'first_name': 'Lucy', 'last_name': 'McBath', 'fax': '2022254656'},
            {'first_name': 'Michael', 'last_name': 'San Nicolas', 'fax': '2022260341'},
            {'first_name': 'Abby', 'last_name': 'Finkenauer', 'fax': '2022256666'},
            {'first_name': 'Cynthia', 'last_name': 'Axne', 'fax': '2022253301'},
            {'first_name': 'Russ', 'last_name': 'Fulcher', 'fax': '2022253029'},
            {'first_name': 'Jesús', 'last_name': 'García', 'fax': '2022257810'},
            {'first_name': 'Sean', 'last_name': 'Casten', 'fax': '2022251166'},
            {'first_name': 'Lauren', 'last_name': 'Underwood', 'fax': '2022250697'},
            {'first_name': 'James', 'last_name': 'Baird', 'fax': '2022260544'},
            {'first_name': 'Greg', 'last_name': 'Pence', 'fax': '7652167993'},
            {'first_name': 'Steven', 'last_name': 'Watkins', 'fax': '2022257986'},
            {'first_name': 'Sharice', 'last_name': 'Davids', 'fax': '2022252807'},
            {'first_name': 'Lori', 'last_name': 'Trahan', 'fax': '2022260771'},
            {'first_name': 'Ayanna', 'last_name': 'Pressley', 'fax': '2022259322'},
            {'first_name': 'David', 'last_name': 'Trone', 'fax': '2022252193'},
            {'first_name': 'Elissa', 'last_name': 'Slotkin', 'fax': '8442394485'},
            {'first_name': 'Andy', 'last_name': 'Levin', 'fax': '2022261033'},
            {'first_name': 'Haley', 'last_name': 'Stevens', 'fax': '2022252667'},
            {'first_name': 'Rashida', 'last_name': 'Tlaib', 'fax': '2022250072'},
            {'first_name': 'Jim', 'last_name': 'Hagedorn', 'fax': '2022253433'},
            {'first_name': 'Angie', 'last_name': 'Craig', 'fax': '2022252595'},
            {'first_name': 'Dean', 'last_name': 'Phillips', 'fax': '2022256351'},
            {'first_name': 'Ilhan', 'last_name': 'Omar', 'fax': '2022254886'},
            {'first_name': 'Pete', 'last_name': 'Stauber', 'fax': '2022250699'},
            {'first_name': 'Michael', 'last_name': 'Guest', 'fax': '2022255797'},
            {'first_name': 'Kelly', 'last_name': 'Armstrong', 'fax': '2022260893'},
            {'first_name': 'Chris', 'last_name': 'Pappas', 'fax': '2022255822'},
            {'first_name': 'Jefferson', 'last_name': 'Van Drew', 'fax': '2022253318'},
            {'first_name': 'Andy', 'last_name': 'Kim', 'fax': '2022250778'},
            {'first_name': 'Tom', 'last_name': 'Malinowski', 'fax': '2022259460'},
            {'first_name': 'Mikie', 'last_name': 'Sherrill', 'fax': '2022253186'},
            {'first_name': 'Debra', 'last_name': 'Haaland', 'fax': '2022254975'},
            {'first_name': 'Xochitl', 'last_name': 'Torres Small', 'fax': '2022259599'},
            {'first_name': 'Susie', 'last_name': 'Lee', 'fax': '2022252185'},
            {'first_name': 'Max', 'last_name': 'Rose', 'fax': '2022261272'},
            {'first_name': 'Alexandria', 'last_name': 'Ocasio-Cortez', 'fax': '2022251909'},
            {'first_name': 'Antonio', 'last_name': 'Delgado', 'fax': '2022251168'},
            {'first_name': 'Anthony', 'last_name': 'Brindisi', 'fax': '2022251891'},
            {'first_name': 'Anthony', 'last_name': 'Gonzalez', 'fax': '2022253059'},
            {'first_name': 'Kendra', 'last_name': 'Horn', 'fax': '2022261463'},
            {'first_name': 'Madeleine', 'last_name': 'Dean', 'fax': '6102751759'},
            {'first_name': 'Chrissy', 'last_name': 'Houlahan', 'fax': '2022258440'},
            {'first_name': 'Daniel', 'last_name': 'Meuser', 'fax': '2022252486'},
            {'first_name': 'John', 'last_name': 'Joyce', 'fax': '2022252486'},
            {'first_name': 'Guy', 'last_name': 'Reschenthaler', 'fax': '2022253084'},
            {'first_name': 'Joe', 'last_name': 'Cunningham', 'fax': '2022253407'},
            {'first_name': 'William', 'last_name': 'Timmons', 'fax': '2022261177'},
            {'first_name': 'Dusty', 'last_name': 'Johnson', 'fax': '2022255823'},
            {'first_name': 'Tim', 'last_name': 'Burchett', 'fax': '2022256440'},
            {'first_name': 'John', 'last_name': 'Rose', 'fax': '2022256887'},
            {'first_name': 'Mark', 'last_name': 'Green', 'fax': '2022253004'},
            {'first_name': 'Dan', 'last_name': 'Crenshaw', 'fax': '2022255547'},
            {'first_name': 'Van', 'last_name': 'Taylor', 'fax': '2022251485'},
            {'first_name': 'Lance', 'last_name': 'Gooden', 'fax': '2022264888'},
            {'first_name': 'Ron', 'last_name': 'Wright', 'fax': '2022253052'},
            {'first_name': 'Lizzie', 'last_name': 'Fletcher', 'fax': '2022254381'},
            {'first_name': 'Veronica', 'last_name': 'Escobar', 'fax': '2022252016'},
            {'first_name': 'Chip', 'last_name': 'Roy', 'fax': '2022258628'},
            {'first_name': 'Sylvia', 'last_name': 'Garcia', 'fax': '2022259903'},
            {'first_name': 'Colin', 'last_name': 'Allred', 'fax': '2022255878'},
            {'first_name': 'Ben', 'last_name': 'McAdams', 'fax': '2022255638'},
            {'first_name': 'Elaine', 'last_name': 'Luria', 'fax': '2022254218'},
            {'first_name': 'Denver', 'last_name': 'Riggleman', 'fax': '2022255681'},
            {'first_name': 'Ben', 'last_name': 'Cline', 'fax': '2022259681'},
            {'first_name': 'Abigail', 'last_name': 'Spanberger', 'fax': '2022250011'},
            {'first_name': 'Jennifer', 'last_name': 'Wexton', 'fax': '2022250437'},
            {'first_name': 'Kim', 'last_name': 'Schrier', 'fax': '2022254282'},
            {'first_name': 'Bryan', 'last_name': 'Steil', 'fax': '2022253393'},
            {'first_name': 'Carol', 'last_name': 'Miller', 'fax': '2022259061'},
            {'first_name': 'Rick', 'last_name': 'Scott', 'fax': '2022280104'},
            {'first_name': 'Mike', 'last_name': 'Braun', 'fax': '2022245011'},
            {'first_name': 'Joshua', 'last_name': 'Hawley', 'fax': '2022280526'},
            {'first_name': 'Mitt', 'last_name': 'Romney', 'fax': '2022280836'},
            {'first_name': 'Jared', 'last_name': 'Golden', 'fax': '2022252943'},
            {'first_name': 'Fred', 'last_name': 'Keller', 'fax': '7177822887'},
            {'first_name': 'Dan', 'last_name': 'Bishop', 'fax': '2022253389'},
            {'first_name': 'Gregory', 'last_name': 'Murphy', 'fax': '2022253286'},
            {'first_name': 'Kelly', 'last_name': 'Loeffler', 'fax': '2022280724'},
            {'first_name': 'Kweisi', 'last_name': 'Mfume', 'fax': '2022253178'},
            {'first_name': 'Thomas', 'last_name': 'Tiffany', 'fax': '2022253240'},
            {'first_name': 'Mike', 'last_name': 'Garcia', 'fax': '2022260683'},
        ];

        var mayors = [
            {'full_name': 'Bill de Blasio', 'fax': '2124063587'}, // New York City
            {'full_name': 'Eric Garcetti', 'fax': '2139780656'}, // Los Angeles
            {'full_name': 'Lori Lightfoot', 'fax': '3127448045'}, // Chicago
            {'full_name': 'Sylvester Turner', 'fax': '8323931084'}, // Houston
            {'full_name': 'Kate Gallego', 'fax': '6024955583'}, // Phoenix
            {'full_name': 'Jim Kenney', 'fax': '2156861910'}, // Philadelphia
            {'full_name': 'Ron Nirenberg', 'fax': '2102074168'}, // San Antonio
            {'full_name': 'Kevin Faulconer', 'fax': '6192367228'}, // San Diego
            {'full_name': 'Eric Johnson', 'fax': '2146700646'}, // Dallas
            {'full_name': 'Sam Liccardo', 'fax': '4082926207'}, // San Jose
            {'full_name': 'Jacob Frey', 'fax': '6126732305'}, // Minneapolis
        ];

        return {
            get: function() {
                if (!initialized) {
                    initialized = true;
                    $resource(file, {}, {retrieve: {method: 'GET', isArray: true}}).retrieve(function(data) {
                        var legislators = [];
                        _.each(data, function(item) {
                            var legislator = {};
                            legislator.name = item.name.official_full;
                            _.each(item.terms, function(term) {
                                if (term.fax) {
                                    legislator.fax = term.fax;
                                }
                            })
                            if (!legislator.fax) {
                                var foundRep = _.findWhere(missingCongressman, {first_name: item.name.first, last_name: item.name.last});
                                if (foundRep) {
                                    legislator.fax = foundRep.fax;
                                }
                            }
                            legislators.push(legislator);
                        });
                        _.each(mayors, function(mayor) {
                            legislators.push({
                                name: mayor.full_name,
                                fax: mayor.fax,
                            });
                        })
                        d.resolve(legislators);

                        // Scans file for missing legislators
                        // var missingLegislators = [];
                        // _.each(data, function (item) {
                        //     var missingLegislator = {};
                        //     var isFax = false;
                        //     _.each(item.terms, function (term) {
                        //         if (term.fax) {
                        //             isFax = true;
                        //         }
                        //     })
                        //     if (!isFax) {
                        //         missingLegislator.first_name = item.name.first;
                        //         missingLegislator.last_name = item.name.last;
                        //         missingLegislators.push(missingLegislator);
                        //     }
                        // })
                        // console.log(missingLegislators);
                    });
                }
                return d.promise;
            }
        };
    }])
;

/* global angular */
angular.module('ua5App')
    .factory('popup', [function() {
        function show(url, width, height) {
            var h;
            var leftPosition;
            var topPosition;
            var w;
            w = width || 600;
            h = height || 600;
            //Allow for borders.
            leftPosition = (window.screen.width / 2) - ((w / 2) + 10);
            //Allow for title and status bars.
            topPosition = (window.screen.height / 2) - ((h / 2) + 50);
            //Open the window.
            window.open(url, 'Window2', 'status=no,height=' + h + ',width=' + w + ',resizable=yes,left=' + leftPosition + ',top=' + topPosition + ',screenX=' + leftPosition + ',screenY=' + topPosition + ',toolbar=no,menubar=no,scrollbars=no,location=no,directories=no');
            return false;
        }
        return {
            show: show
        };
    }])
;

/* global angular, $ */
// I provide a utility class for preloading image objects.
angular.module('ua5App').factory('preloader', ['$q', '$rootScope', function($q, $rootScope) {
        // I manage the preloading of image objects. Accepts an array of image URLs.
        function Preloader(imageLocations) {
            // I am the image SRC values to preload.
            this.imageLocations = imageLocations;
            // As the images load, we'll need to keep track of the load/error
            // counts when announing the progress on the loading.
            this.imageCount = this.imageLocations.length;
            this.loadCount = 0;
            this.errorCount = 0;
            // I am the possible states that the preloader can be in.
            this.states = {
                PENDING: 1,
                LOADING: 2,
                RESOLVED: 3,
                REJECTED: 4
            };
            // I keep track of the current state of the preloader.
            this.state = this.states.PENDING;
            // When loading the images, a promise will be returned to indicate
            // when the loading has completed (and / or progressed).
            this.deferred = $q.defer();
            this.promise = this.deferred.promise;
        }
        // ---
        // STATIC METHODS.
        // ---
        // I reload the given images [Array] and return a promise. The promise
        // will be resolved with the array of image locations.
        Preloader.preloadImages = function(imageLocations) {
            var preloader = new Preloader(imageLocations);
            return (preloader.load());
        };
        // ---
        // INSTANCE METHODS.
        // ---
        Preloader.prototype = {
            // Best practice for "instnceof" operator.
            constructor: Preloader,
            // ---
            // PUBLIC METHODS.
            // ---
            // I determine if the preloader has started loading images yet.
            isInitiated: function isInitiated() {
                return (this.state !== this.states.PENDING);
            },
            // I determine if the preloader has failed to load all of the images.
            isRejected: function isRejected() {
                return (this.state === this.states.REJECTED);
            },
            // I determine if the preloader has successfully loaded all of the images.
            isResolved: function isResolved() {
                return (this.state === this.states.RESOLVED);
            },
            // I initiate the preload of the images. Returns a promise.
            load: function load() {
                // If the images are already loading, return the existing promise.
                if (this.isInitiated()) {
                    return (this.promise);
                }
                this.state = this.states.LOADING;
                for (var i = 0 ; i < this.imageCount ; i++) {
                    this.loadImageLocation(this.imageLocations[ i ]);
                }
                // Return the deferred promise for the load event.
                return (this.promise);
            },
            // ---
            // PRIVATE METHODS.
            // ---
            // I handle the load-failure of the given image location.
            handleImageError: function handleImageError(imageLocation) {
                this.errorCount++;
                // If the preload action has already failed, ignore further action.
                if (this.isRejected()) {
                    return;
                }
                this.state = this.states.REJECTED;
                this.deferred.reject(imageLocation);
            },
            // I handle the load-success of the given image location.
            handleImageLoad: function handleImageLoad(imageLocation) {
                this.loadCount++;
                // If the preload action has already failed, ignore further action.
                if (this.isRejected()) {
                    return;
                }
                // Notify the progress of the overall deferred. This is different
                // than Resolving the deferred - you can call notify many times
                // before the ultimate resolution (or rejection) of the deferred.
                this.deferred.notify({
                    percent: Math.ceil(this.loadCount / this.imageCount * 100),
                    imageLocation: imageLocation
                });
                // If all of the images have loaded, we can resolve the deferred
                // value that we returned to the calling context.
                if (this.loadCount === this.imageCount) {
                    this.state = this.states.RESOLVED;
                    this.deferred.resolve(this.imageLocations);
                }
            },
            // I load the given image location and then wire the load / error
            // events back into the preloader instance.
            // --
            // NOTE: The load/error events trigger a $digest.
            loadImageLocation: function loadImageLocation(imageLocation) {
                var self = this;
                // When it comes to creating the image object, it is critical that
                // we bind the event handlers BEFORE we actually set the image
                // source. Failure to do so will prevent the events from proper
                // triggering in some browsers.
                var image = $(new Image())
                    .on('load', function(event) {
                            // Since the load event is asynchronous, we have to
                            // tell AngularJS that something changed.
                            $rootScope.$apply(
                                function() {
                                    self.handleImageLoad(event.target.src);
                                    // Clean up object reference to help with the
                                    // garbage collection in the closure.
                                    self = image = event = null;
                                }
                           );
                        }
                    )
                    .prop('src', imageLocation)
                ;
            }
        };
        // Return the factory instance.
        return (Preloader);
    }
]);

/* global angular, $, _, TweenMax, Modernizr */
angular.module('ua5App.about')
    .config(['$stateProvider', '$urlRouterProvider', function($stateProvider, $urlRouterProvider) {
        $stateProvider.state('about', {
            url: '/about',
            templateUrl: 'states/about/about.html',
            controller: 'aboutCtrl',
            controllerAs: 'ctrl'
        });
    }])
    .controller('aboutCtrl', ['$scope', '$timeout', function($scope, $timeout) {
        function init() {
            var $images = $('[data-image-tilt]');

            _.each($images, function(el, i) {
                var $el = $(el);
                var order = i % 2;
                var left, translate, tilt, top;
                var tweenObj;

                switch (order) {
                    case 0:
                        left = '100%';
                        translate = '-100%';
                        tilt = 2;
                        top = 100;
                        break;
                    case 1:
                        left = '50%';
                        translate = '-50%';
                        tilt = -2;
                        top = 120;
                        break;
                }

                if (!Modernizr.touch || window.innerWidth >= 900) { // desktop
                    tweenObj = {
                        left: left,
                        rotation: tilt,
                        top: top,
                        x: translate || 0
                    };

                    TweenMax.set($el, _.clone(tweenObj));
                } else { // mobile
                    TweenMax.set($el, {
                        rotation: Math.random() < 0.5 ? 5 : -5
                    });
                }
            });
        }

        $timeout(init);
    }])
;

/* global angular */
angular.module('ua5App.contribute')
    .config(['$stateProvider', '$urlRouterProvider', function($stateProvider, $urlRouterProvider) {
        $stateProvider.state('contribute', {
            url: '/contribute',
            templateUrl: 'states/contribute/contribute.html',
            controller: 'contributeCtrl',
            controllerAs: 'ctrl'
        });
    }])
    .controller('contributeCtrl', [function() {}])
;

/* global angular, TweenMax, _, $, Modernizr */
angular.module('ua5App.home')
    .config(['$stateProvider', '$urlRouterProvider', function($stateProvider, $urlRouterProvider) {
        $urlRouterProvider.when('', '/');
        $urlRouterProvider.otherwise('/');
        $stateProvider.state('home', {
            url: '/',
            templateUrl: 'states/home/home.html',
            controller: 'HomeCtrl',
            controllerAs: 'ctrl',
            resolve: {
                artworks: ['ArtworksFactory', function(ArtworksFactory) {
                    return ArtworksFactory.get().then(function(data) {
                        return data;
                    });
                }],
                legislators: ['LegislatorsFactory', function(LegislatorsFactory) {
                    return LegislatorsFactory.get().then(function(data) {
                        return data;
                    });
                }]
            }
        });
    }])
    .controller('HomeCtrl', ['$rootScope', 'artworks', '$scope', '$timeout', 'preloader', 'legislators', function($rootScope, artworks, $scope, $timeout, preloader, legislators) {
        var $artworks,
            $artworksOuter,
            $artworksList;

        $rootScope.LEGISLATORS = legislators;

        var top = -500,
            lowestTop = top;

        var selectedArtworkIndex,
            prevArtworkIndex,
            images,
            nextArtworkIndex;
        $rootScope.artworks = artworks;
        $scope.artworksList = $rootScope.artworks;
        $scope.faxArtwork = null;
        $rootScope.preparingFax = false;

        $scope.exitFax = function() {
            $('.fax__form__step').scrollTop(0);
            $rootScope.preparingFax = false;
            $rootScope.selectingArtwork = false;
            $scope.faxArtwork = null;
        };

        $scope.changeArtwork = function(next) {
            if (next) {
                selectedArtworkIndex = (selectedArtworkIndex === $rootScope.artworks.length - 1) ?
                    0 :
                    selectedArtworkIndex + 1;
            } else {
                selectedArtworkIndex = (selectedArtworkIndex === 0) ?
                    $rootScope.artworks.length - 1 :
                    selectedArtworkIndex - 1;
            }

            $scope.faxArtwork = $rootScope.artworks[selectedArtworkIndex];
            getAdjacentArtworks();
        };

        $scope.artists = _.uniq(_.map(artworks, function(artwork) {
            return {
                name: artwork.artist,
                url: artwork.website
            };
        }), false, function(artist) {
            return artist.name;
        });

        function getAdjacentArtworks() {
            if (selectedArtworkIndex === 0) {
                prevArtworkIndex = $rootScope.artworks.length - 1;
            } else {
                prevArtworkIndex = selectedArtworkIndex - 1;
            }

            if (selectedArtworkIndex === $rootScope.artworks.length - 1) {
                nextArtworkIndex = 0;
            } else {
                nextArtworkIndex = selectedArtworkIndex + 1;
            }

            $scope.prevFaxArtwork = $rootScope.artworks[prevArtworkIndex];
            $scope.nextFaxArtwork = $rootScope.artworks[nextArtworkIndex];
        }

        function init() {
            $scope.loadingArtwork = false;
            $artworksOuter = $('.home__artworks');
            $artworks = $('.artwork');
            $artworksList = $('.home__artworks__list');

            _.each($artworks, function(el, i) {
                var $el = $(el);
                var order = i % 3;
                var left, translate, tilt;
                var tweenObj;

                switch (order) {
                    case 0:
                        left = '5%';
                        translate = 0;
                        tilt = -15;
                        top += 700;
                        break;
                    case 1:
                        left = '50%';
                        translate = '-50%';
                        tilt = Math.random() < 0.5 ? -10 : 10;
                        top += 300;
                        break;
                    case 2:
                        left = '95%';
                        translate = '-100%';
                        tilt = 15;
                        top -= 200;
                        break;
                }

                if (top > lowestTop) {
                    lowestTop = top;
                }

                if (!Modernizr.touch || window.innerWidth >= 900) { // desktop
                    tweenObj = {
                        left: left,
                        rotation: tilt,
                        top: top,
                        x: translate || 0
                    };

                    $rootScope.artworks[i].tweenObj = tweenObj;
                    $rootScope.artworks[i].$el = $el;

                    TweenMax.set($el, _.clone(tweenObj));

                    $el.hover(function() {
                        TweenMax.to($el, 0.3, {
                            rotation: 0
                        });
                    }, function() {
                        TweenMax.to($el, 0.3, {
                            rotation: tweenObj.rotation
                        });
                    });

                    $artworksOuter.css({
                        height: lowestTop + 700
                    });
                } else { // mobile
                    TweenMax.set($el, {
                        rotation: Math.random() < 0.5 ? 5 : -5
                    });
                }

                $el.on('click', function() {
                    selectedArtworkIndex = i;
                    $scope.faxArtwork = $rootScope.artworks[i];
                    getAdjacentArtworks();
                    $rootScope.preparingFax = true;
                    $rootScope.selectingArtwork = true;
                    $rootScope.$apply();
                });
            });

            if (Modernizr.touch && window.innerWidth < 900) {
                $artworksList.slick({
                    arrows: false
                });
            }

            //Move between artworks if user uses keyboard left/right arrows
            $('body').keydown(function(e) {
                if ($scope.faxArtwork) {
                    if (e.keyCode === 37 && $rootScope.selectingArtwork) {
                        $scope.changeArtwork(false);
                    } else if (e.keyCode === 39 && $rootScope.selectingArtwork) {
                        $scope.changeArtwork(true);
                    } else if (e.keyCode === 27) {
                        $scope.exitFax();
                    }

                    $scope.$apply();
                }
            });
        }

        images = _.map(artworks, function(art) {
            return art.image;
        });
        thumbs = _.map(artworks, function(art) {
            return art.image_small;
        });

        $scope.loadingArtwork = true;

        preloader.preloadImages(thumbs).then(init);
    }])
;

/* global angular */
angular.module('ua5App.terms')
    .config(['$stateProvider', '$urlRouterProvider', function($stateProvider, $urlRouterProvider) {
        $stateProvider.state('terms', {
            url: '/terms',
            templateUrl: 'states/terms/terms.html',
            controller: 'termsCtrl',
            controllerAs: 'ctrl',
            resolve: {
                terms: ['$http', function($http) {
                    return $http.get('/data/terms.json');
                }],
                privacy: ['$http', function($http) {
                    return $http.get('/data/privacy.json');
                }]
            }
        });
    }])
    .controller('termsCtrl', ['$rootScope', '$scope', 'terms', 'privacy', function($rootScope, $scope, terms, privacy) {
        //Don't need the intro on terms page -sam
        $rootScope.introDismissed = true;

        $scope.terms = terms && terms.data ? terms.data.terms : null;
        $scope.privacy = privacy && privacy.data ? privacy.data.privacy : null;
    }])
;

angular.module('ua5Templates').run(['$templateCache', function($templateCache) {
  'use strict';

  $templateCache.put('components/artwork/artwork.html',
    "<div\n" +
    "    class=\"artwork\"\n" +
    "    analytics-on analytics-event=\"click\"\n" +
    "    analytics-category=\"artwork\"\n" +
    "    analytics-label=\"{{artworkData.artist}}\"\n" +
    "    ng-class=\"{'preparing-fax': artworkData.preparingFax}\">\n" +
    "    <div class=\"artwork__image\">\n" +
    "        <img ng-src=\"{{artworkData.image_small}}\">\n" +
    "    </div>\n" +
    "	<div class=\"artwork__page\">\n" +
    "        <div class=\"artwork__page__placeholder header\">\n" +
    "            <div class=\"artwork__page__placeholder__line\"></div><div class=\"artwork__page__placeholder__line\"></div><div class=\"artwork__page__placeholder__line\"></div>\n" +
    "        </div>\n" +
    "        <div class=\"artwork__page__placeholder-image\"></div>\n" +
    "        <div class=\"artwork__page__placeholder body\">\n" +
    "            <div class=\"artwork__page__placeholder__line\"></div><div class=\"artwork__page__placeholder__line\"></div><div class=\"artwork__page__placeholder__line\"></div><div class=\"artwork__page__placeholder__line\"></div><div class=\"artwork__page__placeholder__line\"></div><div class=\"artwork__page__placeholder__line\"></div>\n" +
    "        </div>\n" +
    "        <div class=\"artwork__page__placeholder footer-artwork\">\n" +
    "            <div class=\"artwork__page__placeholder__line\"></div><div class=\"artwork__page__placeholder__line\"></div>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "    <div class=\"artwork__info\">\n" +
    "        <div class=\"artwork__info__title\">\n" +
    "            <span ng-bind=\"artworkData.title\"></span> <span class=\"artwork__info__new\" ng-if=\"artworkData.new\">New</span>\n" +
    "        </div>\n" +
    "        <div\n" +
    "            class=\"artwork__info__artist\"\n" +
    "            ng-bind=\"artworkData.artist\">\n" +
    "        </div>\n" +
    "    </div>\n" +
    "</div>\n"
  );


  $templateCache.put('components/contact-form/contact-form.html',
    "<form\n" +
    "    class=\"contact-form\"\n" +
    "    ng-submit=\"formSubmit(model)\"\n" +
    "    name=\"contactForm\">\n" +
    "	<div class=\"contact-form__title\">\n" +
    "        Got questions or comments?\n" +
    "    </div>\n" +
    "    <div class=\"contact-form__name-inputs\">\n" +
    "        <input\n" +
    "            class=\"contact-form__input name\"\n" +
    "            type=\"text\"\n" +
    "            id=\"name\"\n" +
    "            name=\"name\"\n" +
    "            placeholder=\"Name*\"\n" +
    "            ng-model=\"model.name\"\n" +
    "            data-form-field\n" +
    "            required>\n" +
    "        <input\n" +
    "            class=\"contact-form__input email\"\n" +
    "            type=\"email\"\n" +
    "            id=\"email\"\n" +
    "            name=\"email\"\n" +
    "            placeholder=\"Email*\"\n" +
    "            ng-pattern=\"/^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\\.[a-zA-Z0-9-]+)*$/\"\n" +
    "            ng-init=\"emailFocus=false\"\n" +
    "            ng-focus=\"emailFocus=true\"\n" +
    "            ng-blur=\"emailFocus=false\"\n" +
    "            ng-class=\"{'error': contactForm.email.$error.email && !emailFocus}\"\n" +
    "            ng-model=\"model.email\"\n" +
    "            data-form-field\n" +
    "            required>\n" +
    "    </div>\n" +
    "    <div class=\"contact-form__field contact-form__field-message\">\n" +
    "        <textarea\n" +
    "            id=\"message\"\n" +
    "            name=\"message\"\n" +
    "            placeholder=\"Message*\"\n" +
    "            class=\"contact-form__textarea\"\n" +
    "            ng-model=\"model.message\"\n" +
    "            rows=6\n" +
    "            data-form-field\n" +
    "            msd-elastic\n" +
    "            required>\n" +
    "        </textarea>\n" +
    "    </div>\n" +
    "    <div class=\"contact-form__submit-wrapper\">\n" +
    "        <input\n" +
    "            type=\"submit\"\n" +
    "            value=\"Submit\"\n" +
    "            class=\"contact-form__submit\"\n" +
    "            ng-disabled=\"contactForm.$invalid || disableButton\">\n" +
    "    </div>\n" +
    "    <div\n" +
    "        class=\"contact-form__error\"\n" +
    "        ng-if=\"formSubmitError\"\n" +
    "        ng-bind-html=\"formSubmitError\">\n" +
    "    </div>\n" +
    "</form>\n" +
    "<div class=\"contact-form__succcess\">\n" +
    "    <div class=\"contact-form__succcess__header\">\n" +
    "        <div\n" +
    "            class=\"contact-form__succcess__checkmark\"\n" +
    "            ng-include=\"'assets/images/checkmark.svg'\">\n" +
    "        </div>\n" +
    "        <div>Thank You!</div>\n" +
    "    </div>\n" +
    "    <div class=\"contact-form__succcess__subheader\">\n" +
    "        We've received your message.\n" +
    "    </div>\n" +
    "</div>\n"
  );


  $templateCache.put('components/contribute-form/contribute-form.html',
    "<form\n" +
    "    class=\"contribute-form\"\n" +
    "    ng-submit=\"uploadMedia(model, file)\"\n" +
    "    enctype=\"multipart/form-data\"\n" +
    "    name=\"contributeForm\">\n" +
    "    <div class=\"contribute-form__name-inputs\">\n" +
    "        <input\n" +
    "            class=\"contribute-form__input name\"\n" +
    "            type=\"text\"\n" +
    "            id=\"name\"\n" +
    "            name=\"name\"\n" +
    "            placeholder=\"Name*\"\n" +
    "            ng-model=\"model.name\"\n" +
    "            data-form-field\n" +
    "            required>\n" +
    "        <input\n" +
    "            class=\"contribute-form__input email\"\n" +
    "            type=\"email\"\n" +
    "            id=\"email\"\n" +
    "            name=\"email\"\n" +
    "            placeholder=\"Email*\"\n" +
    "            ng-pattern=\"/^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\\.[a-zA-Z0-9-]+)*$/\"\n" +
    "            ng-init=\"emailFocus=false\"\n" +
    "            ng-focus=\"emailFocus=true\"\n" +
    "            ng-blur=\"emailFocus=false\"\n" +
    "            ng-class=\"{'error': contributeForm.email.$error.email && !emailFocus}\"\n" +
    "            ng-model=\"model.email\"\n" +
    "            data-form-field\n" +
    "            required>\n" +
    "    </div>\n" +
    "    <input\n" +
    "        class=\"contribute-form__input title\"\n" +
    "        type=\"text\"\n" +
    "        id=\"title\"\n" +
    "        name=\"title\"\n" +
    "        placeholder=\"Title of Artwork*\"\n" +
    "        ng-model=\"model.title\"\n" +
    "        data-form-field\n" +
    "        required>\n" +
    "    <div class=\"contribute-form__field contribute-form__field-artwork\">\n" +
    "        <div class=\"contribute-form__field-artwork-label\">\n" +
    "            <span>Artwork Specifications</span>\n" +
    "            <span>JPG file  /  8.5 x 6.5 in  /  300dpi  /  Black and White</span>\n" +
    "        </div>\n" +
    "        <div\n" +
    "            class=\"contribute-form__field__upload\"\n" +
    "            name=\"file\"\n" +
    "            ngf-select=\"\"\n" +
    "            ngf-drop=\"\"\n" +
    "            ng-model=\"file\"\n" +
    "            ngf-max-files=\"1\"\n" +
    "            ngf-accept=\"'image/jpeg,image/jpg'\"\n" +
    "            ngf-validate-fn=\"mediaValidate($file)\"\n" +
    "            ngf-fix-orientation=\"true\"\n" +
    "            required>\n" +
    "            <span class=\"contribute-form__field__upload__title\">\n" +
    "                Drop Image Here\n" +
    "                <div\n" +
    "                    ng-if=\"mediaFileError\"\n" +
    "                    class=\"contribute-form__field__upload__file__error\"\n" +
    "                    ng-bind-html=\"mediaFileError\">\n" +
    "                </div>\n" +
    "            </span>\n" +
    "            <div\n" +
    "                class=\"contribute-form__field__upload__thumbnail\"\n" +
    "                ngf-thumbnail=\"file\"\n" +
    "                ngf-as-background=\"true\">\n" +
    "            </div>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "    <div class=\"contribute-form__field contribute-form__field-terms\">\n" +
    "        <div\n" +
    "            class=\"contribute-form__field-radio\"\n" +
    "            ng-class=\"{agreed: agreed}\"\n" +
    "            ng-click=\"agreeToTerms()\"\n" +
    "            ng-include=\"'assets/images/checkmark.svg'\">\n" +
    "        </div>\n" +
    "        <div class=\"contribute-form__radio-label\">I agree to the <a ui-sref=\"terms\" target=\"_black\">terms of service</a></div>\n" +
    "    </div>\n" +
    "    <div class=\"contribute-form__submit-wrapper\">\n" +
    "        <input\n" +
    "            type=\"submit\"\n" +
    "            value=\"Submit Your Artwork\"\n" +
    "            class=\"contribute-form__submit\"\n" +
    "            ng-disabled=\"contributeForm.$invalid || !agreed || disableButton\">\n" +
    "    </div>\n" +
    "    <div\n" +
    "        class=\"contribute-form__error\"\n" +
    "        ng-if=\"formSubmitError\"\n" +
    "        ng-bind-html=\"formSubmitError\">\n" +
    "    </div>\n" +
    "</form>\n" +
    "<div class=\"contribute-form__succcess\">\n" +
    "    <div class=\"contribute-form__succcess__header\">\n" +
    "        <div\n" +
    "            class=\"contribute-form__field-radio\"\n" +
    "            ng-include=\"'assets/images/checkmark.svg'\">\n" +
    "        </div>\n" +
    "        <div>Thank You!</div>\n" +
    "    </div>\n" +
    "    <div class=\"contribute-form__succcess__subheader\">\n" +
    "        We've received your contribution.\n" +
    "    </div>\n" +
    "</div>\n"
  );


  $templateCache.put('components/fax-generator/fax-generator.html',
    "<!-- width: 80%; position: absolute; z-index: 1000 -->\n" +
    "<canvas id=\"fax-canvas\" class=\"canvas\" width=\"1275\" height=\"1650\"></canvas>\n"
  );


  $templateCache.put('components/fax-page/fax-page.html',
    "<div class=\"fax-page\">\n" +
    "    <div class=\"fax-page__header\">\n" +
    "        <div class=\"fax-page__slogan\">\n" +
    "            {{title}}\n" +
    "        </div>\n" +
    "        <div class=\"fax-page__title\">\n" +
    "            <p class=\"fax-page__header__key\">\n" +
    "                Title of artwork:\n" +
    "            </p>\n" +
    "            <p\n" +
    "                class=\"fax-page__header__value\"\n" +
    "                ng-bind=\"faxArtwork.title\">\n" +
    "            </p>\n" +
    "        </div>\n" +
    "        <div class=\"fax-page__artist\">\n" +
    "            <p class=\"fax-page__header__key\">\n" +
    "                Artwork by:\n" +
    "            </p>\n" +
    "            <p\n" +
    "                class=\"fax-page__header__value\"\n" +
    "                ng-bind=\"faxArtwork.artist\">\n" +
    "            </p>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "    <div class=\"fax-page__artwork\">\n" +
    "        <img ng-src=\"{{faxArtwork.image}}\">\n" +
    "    </div>\n" +
    "    <div class=\"fax-page__body\">\n" +
    "        <div class=\"fax-page__message\">\n" +
    "            <p class=\"fax-page__message__salutation\">\n" +
    "                Dear <span ng-bind=\"selectedRepresentative.prefix\"></span> <span ng-bind=\"selectedRepresentative.name\"></span>,\n" +
    "            </p>\n" +
    "            <p\n" +
    "                class=\"fax-page__message__body\"\n" +
    "                ng-bind=\"message\">\n" +
    "            </p>\n" +
    "            <p class=\"fax-page__message__closing\">Sincerely,</p>\n" +
    "        </div>\n" +
    "        <div class=\"fax-page__footer\">\n" +
    "            <div class=\"fax-page__signature\">\n" +
    "                <img\n" +
    "                    class=\"fax-page__signature__image\"\n" +
    "                    ng-src=\"{{signatureImage}}\">\n" +
    "                <div\n" +
    "                    class=\"fax-page__registration\"\n" +
    "                    ng-if=\"registered\">\n" +
    "                    <p>\n" +
    "                        I am registered to vote\n" +
    "                    </p>\n" +
    "                </div>\n" +
    "            </div>\n" +
    "            <div class=\"fax-page__sender\">\n" +
    "                <p class=\"fax-page__sender__name\">\n" +
    "                    <span ng-bind=\"name.first\"></span> <span ng-bind=\"name.last\"></span> &nbsp;&nbsp;&nbsp;&nbsp;<span ng-bind=\"date\"></span>\n" +
    "                </p>\n" +
    "                <p\n" +
    "                    class=\"fax-page__sender__zipcode\"\n" +
    "                    ng-bind=\"address\">\n" +
    "                </p>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "</div>\n"
  );


  $templateCache.put('components/fax/fax.html',
    "<div\n" +
    "    class=\"fax {{stage}}\"\n" +
    "    ng-class=\"{'first-step': stepIndex === 0, 'last-step': stepIndex === steps.length - 1}\">\n" +
    "    <div\n" +
    "        class=\"fax__exit\"\n" +
    "        ng-click=\"exitFax()\">\n" +
    "        <span></span>\n" +
    "        <span></span>\n" +
    "    </div>\n" +
    "    <div class=\"fax__inner\">\n" +
    "        <div\n" +
    "            class=\"fax__form\"\n" +
    "            ng-class=\"{returning: returningToForm}\">\n" +
    "            <div\n" +
    "                class=\"fax__form__back\"\n" +
    "                ng-click=\"changeStep(false)\">\n" +
    "                <div\n" +
    "                    class=\"fax__back__arrow\"\n" +
    "                    ng-include=\"'assets/images/up-arrow.svg'\">\n" +
    "                </div>\n" +
    "                <div class=\"fax__back__text\">Back</div>\n" +
    "            </div>\n" +
    "            <div class=\"fax__form__steps step--{{formStep.number}}\">\n" +
    "                <div\n" +
    "                    class=\"fax__form__step fax__form__step--1 artwork-info\"\n" +
    "                    ng-class=\"{current: formStep.number === 1, prev: formStep.number > 1}\">\n" +
    "                    <div class=\"fax__form__step-header outside\">\n" +
    "                        <div class=\"fax__form__step-header__number\">\n" +
    "                            Step 1 of 6\n" +
    "                        </div>\n" +
    "                        <div\n" +
    "                            class=\"fax__form__step-header__title\"\n" +
    "                            ng-bind=\"steps[0].title\">\n" +
    "                        </div>\n" +
    "                    </div>\n" +
    "                    <div class=\"fax__form__step__component\">\n" +
    "                        <div class=\"fax__artwork\">\n" +
    "                            <button\n" +
    "                                analytics-on analytics-event=\"click\"\n" +
    "                                analytics-category=\"step1\"\n" +
    "                                analytics-category=\"Next: Top Find Your Elected Official CTA\"\n" +
    "                                class=\"fax__form__continue__button fax__form__continue__button--top\"\n" +
    "                                ng-click=\"changeStep(true)\"\n" +
    "                                ng-disabled=\"!stepValid\">Select this Artwork\n" +
    "                            </button>\n" +
    "                            <img ng-src=\"{{faxArtwork.image}}\">\n" +
    "                            <div\n" +
    "                                class=\"fax__artwork__mobile-toggle back\"\n" +
    "                                ng-include=\"'assets/images/carat-arrow.svg'\"\n" +
    "                                ng-click=\"prevArtwork()\">\n" +
    "                            </div>\n" +
    "                            <div\n" +
    "                                class=\"fax__artwork__mobile-toggle forward\"\n" +
    "                                ng-include=\"'assets/images/carat-arrow.svg'\"\n" +
    "                                ng-click=\"nextArtwork()\">\n" +
    "                            </div>\n" +
    "                        </div>\n" +
    "                        <div\n" +
    "                            class=\"fax__artwork__title\"\n" +
    "                            ng-bind=\"faxArtwork.title\"></div>\n" +
    "                        <div class=\"fax__artwork__artist\">\n" +
    "                            by <a\n" +
    "                                ng-if=\"faxArtwork.website\"\n" +
    "                                ng-bind=\"faxArtwork.artist\"\n" +
    "                                href=\"{{faxArtwork.website}}\"\n" +
    "                                target=\"blank_\"></a>\n" +
    "                            <span ng-if=\"!faxArtwork.website\" ng-bind=\"faxArtwork.artist\"></span>\n" +
    "                        </div>\n" +
    "                        <div\n" +
    "                            class=\"fax__artwork__subartists\"\n" +
    "                            ng-if=\"faxArtwork.subartists\"\n" +
    "                            ng-bind=\"faxArtwork.subartists\">\n" +
    "                        </div>\n" +
    "                    </div>\n" +
    "                    <div class=\"fax__form__continue\">\n" +
    "                        <button\n" +
    "                            analytics-on analytics-event=\"click\"\n" +
    "                            analytics-category=\"step1\"\n" +
    "                            analytics-category=\"Next: Find Your Elected Official CTA\"\n" +
    "                            class=\"fax__form__continue__button\"\n" +
    "                            ng-click=\"changeStep(true)\"\n" +
    "                            ng-disabled=\"!stepValid\"\n" +
    "                            ng-bind=\"steps[0].continueText\">\n" +
    "                        </button>\n" +
    "                    </div>\n" +
    "                </div>\n" +
    "                <div\n" +
    "                    class=\"fax__form__step fax__form__step--2 zipcode\"\n" +
    "                    ng-class=\"{current: formStep.number === 2, prev: formStep.number > 2, next: formStep.number < 2}\">\n" +
    "                    <div class=\"fax__form__step-header\">\n" +
    "                        <div class=\"fax__form__step-header__number\">\n" +
    "                            Step 2 of 6\n" +
    "                        </div>\n" +
    "                        <div\n" +
    "                            class=\"fax__form__step-header__title\"\n" +
    "                            ng-bind=\"steps[1].title\">\n" +
    "                        </div>\n" +
    "                    </div>\n" +
    "                    <div class=\"fax__form__step__component\">\n" +
    "                        <div class=\"fax__form__explanation\">\n" +
    "                            Enter your full address and zip code to find your elected officials. Including your address will verify that you are a constituent to your representative.\n" +
    "                        </div>\n" +
    "                        <div class=\"fax__form__zipcode\">\n" +
    "                            <input\n" +
    "                                class=\"fax__form__zipcode__input\"\n" +
    "                                data-auto-focus\n" +
    "                                type=\"text\"\n" +
    "                                ng-focus=\"faxAddressFocus()\"\n" +
    "                                id=\"address\"\n" +
    "                                name=\"zipcode\"\n" +
    "                                placeholder=\"Your full address\"\n" +
    "                                autocomplete=\"new-password\"\n" +
    "                                ng-model=\"zipcode\">\n" +
    "                            <div\n" +
    "                                class=\"fax__form__zipcode__invalid\"\n" +
    "                                ng-class=\"{visible: !validZip}\">\n" +
    "                                Please enter a valid address\n" +
    "                            </div>\n" +
    "                        </div>\n" +
    "                    </div>\n" +
    "                    <div class=\"fax__form__continue\">\n" +
    "                        <button\n" +
    "                            analytics-on analytics-event=\"click\"\n" +
    "                            analytics-category=\"step2\"\n" +
    "                            analytics-label=\"select official cta\"\n" +
    "                            class=\"fax__form__continue__button\"\n" +
    "                            ng-click=\"changeStep(true)\"\n" +
    "                            ng-bind=\"steps[1].continueText\">\n" +
    "                        </button>\n" +
    "                    </div>\n" +
    "                </div>\n" +
    "                <div\n" +
    "                    class=\"fax__form__step fax__form__step--3 representative\"\n" +
    "                    ng-class=\"{current: formStep.number === 3, prev: formStep.number > 3, next: formStep.number < 3}\">\n" +
    "                    <div class=\"fax__form__step-header\">\n" +
    "                        <div class=\"fax__form__step-header__number\">\n" +
    "                            Step 3 of 6\n" +
    "                        </div>\n" +
    "                        <div\n" +
    "                            class=\"fax__form__step-header__title\"\n" +
    "                            ng-bind=\"steps[2].title\">\n" +
    "                        </div>\n" +
    "                    </div>\n" +
    "                    <div class=\"fax__form__step__component\">\n" +
    "                        <div class=\"fax__form__representative__zipcode\">\n" +
    "                            <span ng-bind=\"address\"></span>\n" +
    "                            <a ng-click=\"changeStep(false)\">Change</a>\n" +
    "                        </div>\n" +
    "                        <div class=\"fax__form__explanation\">\n" +
    "                            Below is a list of your state’s Senators and Representatives within your area.\n" +
    "                        </div>\n" +
    "                        <div\n" +
    "                            class=\"fax__form__representative__list\"\n" +
    "                            ng-class=\"{'representative-selected': !!selectedRepresentative}\">\n" +
    "                            <div\n" +
    "                                class=\"fax__form__representative__person\"\n" +
    "                                ng-class=\"{selected: representative === selectedRepresentative}\"\n" +
    "                                analytics-on analytics-event=\"click\"\n" +
    "                                analytics-category=\"step3\"\n" +
    "                                analytics-label=\"select rep: {{representative.name}}\"\n" +
    "                                ng-repeat=\"representative in representatives\"\n" +
    "                                ng-click=\"setRepresentative(representative)\">\n" +
    "                                <div\n" +
    "                                    class=\"fax__form__representative__person__photo\"\n" +
    "                                    ng-style={'background-image':'url({{representative.image}})'}>\n" +
    "                                </div>\n" +
    "                                <div class=\"fax__form__representative__person__info\">\n" +
    "                                    <div\n" +
    "                                        class=\"fax__form__representative__person__checkmark\"\n" +
    "                                        ng-include=\"'assets/images/checkmark.svg'\">\n" +
    "                                    </div>\n" +
    "                                    <div\n" +
    "                                        class=\"fax__form__representative__person__info__name\"\n" +
    "                                        ng-bind=\"representative.name\">\n" +
    "                                    </div>\n" +
    "                                    <div\n" +
    "                                        class=\"fax__form__representative__person__info__title\"\n" +
    "                                        ng-bind=\"representative.title\">\n" +
    "                                    </div>\n" +
    "                                </div>\n" +
    "                            </div>\n" +
    "                        </div>\n" +
    "                    </div>\n" +
    "                    <div class=\"fax__form__continue\">\n" +
    "                        <button\n" +
    "                            class=\"fax__form__continue__button\"\n" +
    "                            analytics-on analytics-event=\"click\"\n" +
    "                            analytics-category=\"step3\"\n" +
    "                            analytics-label=\"confirm status\"\n" +
    "                            ng-click=\"changeStep(true)\"\n" +
    "                            ng-disabled=\"!stepValid\"\n" +
    "                            ng-bind=\"steps[2].continueText\">\n" +
    "                        </button>\n" +
    "                    </div>\n" +
    "                </div>\n" +
    "                <div\n" +
    "                    class=\"fax__form__step fax__form__step--4 registration\"\n" +
    "                    ng-class=\"{current: formStep.number === 4, prev: formStep.number > 4, next: formStep.number < 4}\">\n" +
    "                    <div class=\"fax__form__step-header\">\n" +
    "                        <div class=\"fax__form__step-header__number\">\n" +
    "                            Step 4 of 6\n" +
    "                        </div>\n" +
    "                        <div\n" +
    "                            class=\"fax__form__step-header__title\"\n" +
    "                            ng-bind=\"steps[3].title\">\n" +
    "                        </div>\n" +
    "                    </div>\n" +
    "                    <div class=\"fax__form__step__component\">\n" +
    "                        <div class=\"fax__form__explanation\">\n" +
    "                            Knowing your registration status helps your elected official confirm that you are a valued constituent.\n" +
    "                        </div>\n" +
    "                        <div\n" +
    "                            class=\"fax__form__registration__options\"\n" +
    "                            ng-class=\"{'option-selected': registered !== undefined}\">\n" +
    "                            <div\n" +
    "                                class=\"fax__form__registration__option\"\n" +
    "                                ng-class=\"{selected: registered === true}\">\n" +
    "                                <div\n" +
    "                                    class=\"fax__form__registration__option__radio\"\n" +
    "                                    analytics-on analytics-event=\"click\"\n" +
    "                                    analytics-category=\"step4\"\n" +
    "                                    analytics-label=\"registered voter\"\n" +
    "                                    ng-click=\"setRegistration(true)\">\n" +
    "                                    <div\n" +
    "                                        class=\"fax__form__registration__option__radio__inner\"\n" +
    "                                        ng-include=\"'assets/images/checkmark.svg'\">\n" +
    "                                    </div>\n" +
    "                                </div>\n" +
    "                                <div ng-click=\"setRegistration(true)\" class=\"fax__form__registration__option__description\">\n" +
    "                                    Yes, I’m a registered voter!\n" +
    "                                </div>\n" +
    "                            </div>\n" +
    "                            <div\n" +
    "                                class=\"fax__form__registration__option\"\n" +
    "                                ng-class=\"{selected: registered === false}\">\n" +
    "                                <div\n" +
    "                                    analytics-on analytics-event=\"click\"\n" +
    "                                    analytics-category=\"step4\"\n" +
    "                                    analytics-label=\"not registered voter\"\n" +
    "                                    class=\"fax__form__registration__option__radio\"\n" +
    "                                    ng-click=\"setRegistration(false)\">\n" +
    "                                    <div\n" +
    "                                        class=\"fax__form__registration__option__radio__inner\"\n" +
    "                                        ng-include=\"'assets/images/checkmark.svg'\">\n" +
    "                                    </div>\n" +
    "                                </div>\n" +
    "                                <div class=\"fax__form__registration__option__description\">\n" +
    "                                    <div ng-click=\"setRegistration(false)\">No, I’m not a registered voter</div>\n" +
    "                                    <a\n" +
    "                                        class=\"fax__form__registration__option__link\"\n" +
    "                                        href=\"https://www.vote.org/am-i-registered-to-vote/\"\n" +
    "                                        target=\"_blank\">\n" +
    "                                        Find out if you’re registered\n" +
    "                                    </a>\n" +
    "                                </div>\n" +
    "                            </div>\n" +
    "                        </div>\n" +
    "                    </div>\n" +
    "                    <div class=\"fax__form__continue\">\n" +
    "                        <button\n" +
    "                            analytics-on analytics-event=\"click\"\n" +
    "                            analytics-category=\"step4\"\n" +
    "                            analytics-label=\"Next: Write Your Message\"\n" +
    "                            class=\"fax__form__continue__button\"\n" +
    "                            ng-click=\"changeStep(true)\"\n" +
    "                            ng-disabled=\"!stepValid\"\n" +
    "                            ng-bind=\"steps[3].continueText\">\n" +
    "                        </button>\n" +
    "                    </div>\n" +
    "                </div>\n" +
    "                <div\n" +
    "                    class=\"fax__form__step fax__form__step--5 message\"\n" +
    "                    ng-class=\"{current: formStep.number === 5, prev: formStep.number > 5, next: formStep.number < 5}\">\n" +
    "                    <div class=\"fax__form__step-header\">\n" +
    "                        <div class=\"fax__form__step-header__number\">\n" +
    "                            Step 5 of 6\n" +
    "                        </div>\n" +
    "                        <div\n" +
    "                            class=\"fax__form__step-header__title\"\n" +
    "                            ng-bind=\"steps[4].title\">\n" +
    "                        </div>\n" +
    "                    </div>\n" +
    "                    <div class=\"fax__form__step__component\">\n" +
    "                        <div class=\"fax__form__explanation\">\n" +
    "                            Congress works for YOU! If there is a policy you support or oppose, let your congressperson know.\n" +
    "                            <p>Or - select from one of our pre-filled topics:</p>\n" +
    "                            <select ng-model=\"selectedItem\" ng-change=\"selectPrefilled()\">\n" +
    "                                <option ng-repeat=\"(index, option) in prefilledMessages\" value=\"{{index}}\">{{option.name}}</option>\n" +
    "                            </select>\n" +
    "                        </div>\n" +
    "                        <div class=\"fax__form__message\">\n" +
    "                                <label for=\"subject\">Subject:</label>\n" +
    "                                <input\n" +
    "                                    id=\"subject\"\n" +
    "                                    class=\"fax__form__title\"\n" +
    "                                    type=\"text\"\n" +
    "                                    maxlength=\"60\"\n" +
    "                                    ng-model=\"title\"\n" +
    "                                    placeholder=\"Subject\">\n" +
    "                                <div class=\"fax__form__message__salutation\">\n" +
    "                                    Dear <span ng-bind=\"selectedRepresentative.prefix\"></span> <span ng-bind=\"selectedRepresentative.name\"></span>,\n" +
    "                                </div>\n" +
    "                                <textarea\n" +
    "                                    class=\"fax__form__message__textarea\"\n" +
    "                                    placeholder=\"Here are some suggestions your fax:\n" +
    "Keep the fax short, focused, direct and polite\n" +
    "Make your position explicit from the beginning. What bill or issue are you concerned about, and should your congressperson support or oppose it?\n" +
    "Explain why you support or oppose the issue\n" +
    "If you are a constituent, let them know. Do not lie about being a constituent, as this can diminish the effect of actual constituent communication\"\n" +
    "                                    ng-model=\"message\"\n" +
    "                                    ng-keydown=\"countMessageWords($event)\"\n" +
    "                                    ng-keyup=\"countMessageWords($event)\"\n" +
    "                                    rows=10\n" +
    "                                    msd-elastic>\n" +
    "                                </textarea>\n" +
    "                            <div class=\"fax__form__message__inner\">\n" +
    "                                <div class=\"fax__form__message__clear-info\">\n" +
    "                                    <div\n" +
    "                                        class=\"fax__form__message__wordcount\"\n" +
    "                                        ng-class=\"{visible: messageWordCount > 0, max: wordLimitReached}\">\n" +
    "                                        (<span ng-bind=\"messageWordCount\"></span>)\n" +
    "                                    </div>\n" +
    "                                    <div\n" +
    "                                        class=\"fax__form__message__clear\"\n" +
    "                                        ng-class=\"{visible: messageWordCount > 0}\"\n" +
    "                                        ng-click=\"clearMessage()\">\n" +
    "                                        Clear\n" +
    "                                    </div>\n" +
    "                                </div>\n" +
    "                            </div>\n" +
    "                        </div>\n" +
    "                    </div>\n" +
    "                    <div class=\"fax__form__continue\">\n" +
    "                        <button\n" +
    "                            analytics-on analytics-event=\"click\"\n" +
    "                            analytics-category=\"step5\"\n" +
    "                            analytics-label=\"Next: Add Your Name & Sign!\"\n" +
    "                            class=\"fax__form__continue__button\"\n" +
    "                            ng-click=\"changeStep(true)\"\n" +
    "                            ng-disabled=\"!stepValid\"\n" +
    "                            ng-bind=\"steps[4].continueText\">\n" +
    "                        </button>\n" +
    "                    </div>\n" +
    "                </div>\n" +
    "                <div\n" +
    "                    class=\"fax__form__step fax__form__step--6 signature\"\n" +
    "                    ng-class=\"{current: formStep.number === 6, next: formStep.number < 6}\">\n" +
    "                    <div class=\"fax__form__step-header\">\n" +
    "                        <div class=\"fax__form__step-header__number\">\n" +
    "                            Step 6 of 6\n" +
    "                        </div>\n" +
    "                        <div\n" +
    "                            class=\"fax__form__step-header__title\"\n" +
    "                            ng-bind=\"steps[5].title\">\n" +
    "                        </div>\n" +
    "                    </div>\n" +
    "                    <div class=\"fax__form__step__component\">\n" +
    "                        <div class=\"fax__form__explanation\">\n" +
    "                            Use your cursor to sign your name:\n" +
    "                        </div>\n" +
    "                        <div class=\"fax__form__signature\">\n" +
    "                            <div class=\"fax__form__signature__name\">\n" +
    "                                <input\n" +
    "                                    class=\"fax__form__signature__name__input\"\n" +
    "                                    type=\"text\"\n" +
    "                                    maxlength=\"40\"\n" +
    "                                    name=\"first-name\"\n" +
    "                                    placeholder=\"First Name\"\n" +
    "                                    ng-model=\"name.first\"\n" +
    "                                    ng-keyup=\"checkFullName()\"\n" +
    "                                    ng-keydown=\"checkFullName()\">\n" +
    "                                <input\n" +
    "                                    class=\"fax__form__signature__name__input\"\n" +
    "                                    type=\"text\"\n" +
    "                                    maxlength=\"40\"\n" +
    "                                    name=\"last-name\"\n" +
    "                                    placeholder=\"Last Name\"\n" +
    "                                    ng-model=\"name.last\"\n" +
    "                                    ng-keyup=\"checkFullName()\"\n" +
    "                                    ng-keydown=\"checkFullName()\">\n" +
    "                            </div>\n" +
    "                            <div class=\"fax__form__signature__pad-wrapper\">\n" +
    "                                <div class=\"fax__form__signature__icon\"></div>\n" +
    "                                <canvas\n" +
    "                                    class=\"fax__form__signature__pad\"\n" +
    "                                    width=\"100%\"\n" +
    "                                    height=\"100%\">\n" +
    "                                </canvas>\n" +
    "                                <div class=\"fax__form__signature__label\">\n" +
    "                                    Your Signature\n" +
    "                                </div>\n" +
    "                                <span class=\"fax__form__signature__corner\"></span>\n" +
    "                                <span class=\"fax__form__signature__corner\"></span>\n" +
    "                                <span class=\"fax__form__signature__corner\"></span>\n" +
    "                                <span class=\"fax__form__signature__corner\"></span>\n" +
    "                                <div\n" +
    "                                    class=\"fax__form__signature__icon\"\n" +
    "                                    ng-class=\"{hidden: signatureDrawn}\"\n" +
    "                                    ng-include=\"'assets/images/signature-pen.svg'\">\n" +
    "                                </div>\n" +
    "                                <div\n" +
    "                                    class=\"fax__form__signature__clear\"\n" +
    "                                    ng-class=\"{visible: signatureDrawn}\"\n" +
    "                                    ng-click=\"clearSignature()\">\n" +
    "                                    <span></span>\n" +
    "                                    <span></span>\n" +
    "                                </div>\n" +
    "                            </div>\n" +
    "                        </div>\n" +
    "                    </div>\n" +
    "                    <div class=\"fax__form__continue outside\">\n" +
    "                        <button\n" +
    "                            analytics-on analytics-event=\"click\"\n" +
    "                            analytics-category=\"step6\"\n" +
    "                            analytics-label=\"Next: Review & Send Your Fax\"\n" +
    "                            class=\"fax__form__continue__button\"\n" +
    "                            ng-click=\"changeStep(true)\"\n" +
    "                            ng-disabled=\"!stepValid\"\n" +
    "                            ng-bind=\"steps[5].continueText\">\n" +
    "                        </button>\n" +
    "                    </div>\n" +
    "                </div>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "        <div class=\"fax__review\">\n" +
    "            <div class=\"fax__review__inner\">\n" +
    "                <div class=\"fax__review__header\">\n" +
    "                    Review & Send Your Fax\n" +
    "                </div>\n" +
    "                <div\n" +
    "                    class=\"fax__review__page\"\n" +
    "                    fax-page>\n" +
    "                </div>\n" +
    "                <div class=\"fax__review__bottom\">\n" +
    "                    <div class=\"fax__review__edit\">\n" +
    "                        <a ng-click=\"returnToForm()\">Edit Fax</a>\n" +
    "                    </div>\n" +
    "                    <div\n" +
    "                        analytics-on analytics-event=\"click\"\n" +
    "                        analytics-category=\"agree to terms\"\n" +
    "                        analytics-label=\"{{faxArtwork.artist}}, {{selectedRepresentative.name}}\"\n" +
    "                        class=\"fax__review__agreement\"\n" +
    "                        ng-class=\"{agreed: agreed}\"\n" +
    "                        ng-click=\"agreeToTerms()\">\n" +
    "                        <div class=\"fax__review__agreement__radio\">\n" +
    "                            <div\n" +
    "                                class=\"fax__review__agreement__radio__inner\"\n" +
    "                                ng-include=\"'assets/images/checkmark.svg'\">\n" +
    "                            </div>\n" +
    "                        </div>\n" +
    "                        <div class=\"fax__review__agreement__text\">I agree to the <a href=\"/terms\" target=\"_blank\">terms of service</a></div>\n" +
    "                    </div>\n" +
    "                    <div class=\"fax__review__submit\">\n" +
    "                        <button\n" +
    "                            analytics-on analytics-event=\"submit\"\n" +
    "                            analytics-category=\"success\"\n" +
    "                            analytics-label=\"{{faxArtwork.artist}}, {{selectedRepresentative.name}}\"\n" +
    "                            class=\"fax__review__submit__button\"\n" +
    "                            ng-click=\"submitFax()\"\n" +
    "                            ng-disabled=\"!agreed\">\n" +
    "                            Send Fax\n" +
    "                        </button>\n" +
    "                    </div>\n" +
    "                </div>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "        <div class=\"fax__confirmation\">\n" +
    "            <div class=\"fax__confirmation__inner\">\n" +
    "                <div class=\"fax__confirmation__stamp--mobile\">\n" +
    "                    <div ng-include=\"'assets/images/fax-sent.svg'\"></div>\n" +
    "                </div>\n" +
    "                <div\n" +
    "                    class=\"fax__confirmation__page\"\n" +
    "                    fax-page>\n" +
    "                </div>\n" +
    "                <div class=\"fax__confirmation__cta\">\n" +
    "                    <div class=\"fax__confirmation__cta__congrats\">\n" +
    "                        Congratulations!\n" +
    "                    </div>\n" +
    "                    <div class=\"fax__confirmation__cta__info\">\n" +
    "                        Your fax to <span ng-bind=\"selectedRepresentative.prefix\"></span> <span ng-bind=\"selectedRepresentative.name\"></span> was sent at <span ng-bind=\"time\"></span> on <span ng-bind=\"date\"></span>.\n" +
    "                    </div>\n" +
    "                    <a\n" +
    "                        class=\"fax__confirmation__cta__download\"\n" +
    "                        analytics-on analytics-event=\"click\"\n" +
    "                        analytics-category=\"download\"\n" +
    "                        analytics-label=\"{{faxArtwork.artist}}, {{selectedRepresentative.name}}\"\n" +
    "                        ng-click=\"download($event)\">Download Your Fax</a>\n" +
    "                    <div class=\"fax__confirmation__cta__share\">\n" +
    "                        <p>Share Artifax with your friends and family:</p>\n" +
    "                        <div class=\"fax__confirmation__cta__share__outlets\">\n" +
    "                            <a\n" +
    "                                class=\"fax__confirmation__cta__share__outlet twitter\"\n" +
    "                                share-tw\n" +
    "                                share-tw-text=\"Let your voice be heard! Fax your elected representatives with #Artifax\"\n" +
    "                                share-tw-url=\"https://artifax.us/\"\n" +
    "                                ng-include=\"'assets/images/twitter.svg'\">\n" +
    "                            </a>\n" +
    "                            <a\n" +
    "                                class=\"fax__confirmation__cta__share__outlet facebook\"\n" +
    "                                share-fb\n" +
    "                                share-fb-url=\"https://artifax.us/\"\n" +
    "                                ng-include=\"'assets/images/facebook.svg'\">\n" +
    "                            </a>\n" +
    "                            <a\n" +
    "                                share-e\n" +
    "                                share-e-body=\"Fax%20your%20elected%20representatives%20and%20let%20them%20know%20your%20views%20with%20https%3A%2F%2Fartifax.us\"\n" +
    "                                share-e-subject=\"Let%20your%20voice%20be%20heard%21\"\n" +
    "                                class=\"fax__confirmation__cta__share__outlet email\"\n" +
    "                                ng-include=\"'assets/images/email.svg'\">\n" +
    "                            </a>\n" +
    "                        </div>\n" +
    "                    </div>\n" +
    "                    <div class=\"fax__confirmation__cta__send-more\">\n" +
    "                        <button\n" +
    "                            class=\"fax__confirmation__cta__send-more__button\"\n" +
    "                            analytics-on analytics-event=\"click\"\n" +
    "                            analytics-category=\"send another fax\"\n" +
    "                            analytics-label=\"{{faxArtwork.artist}}, {{selectedRepresentative.name}}\"\n" +
    "                            ng-click=\"exitFax()\">\n" +
    "                            Send Another Fax\n" +
    "                        </button>\n" +
    "                    </div>\n" +
    "                </div>\n" +
    "                <div class=\"fax__confirmation__stamp\">\n" +
    "                    <div ng-include=\"'assets/images/fax-sent.svg'\"></div>\n" +
    "                </div>\n" +
    "                <div class=\"fax__confirmation__loader\">\n" +
    "                    <div class=\"fax__confirmation__loader__exclamations\">\n" +
    "                        <div class=\"fax__confirmation__loader__exclamation one\">\n" +
    "                            <div ng-include=\"'assets/images/exclamation.svg'\"></div>\n" +
    "                        </div>\n" +
    "                        <div class=\"fax__confirmation__loader__exclamation two\">\n" +
    "                            <div ng-include=\"'assets/images/exclamation.svg'\"></div>\n" +
    "                        </div>\n" +
    "                        <div class=\"fax__confirmation__loader__exclamation three\">\n" +
    "                            <div ng-include=\"'assets/images/exclamation.svg'\"></div>\n" +
    "                        </div>\n" +
    "                    </div>\n" +
    "                    <div class=\"fax__confirmation__loader__text\">Faxing...</div>\n" +
    "                </div>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "        <div\n" +
    "            class=\"fax__generator\"\n" +
    "            fax-generator>\n" +
    "        </div>\n" +
    "        <canvas id=\"fax__canvas\" width=\"1275\" height=\"1650\"></canvas>\n" +
    "    </div>\n" +
    "</div>\n"
  );


  $templateCache.put('components/footer/footer.html',
    "<div class=\"footer\">\n" +
    "	<div class=\"footer__inner\">\n" +
    "        <div class=\"footer__social\">\n" +
    "            <a\n" +
    "                class=\"footer__item\"\n" +
    "                share-tw\n" +
    "                share-tw-text=\"Let your voice be heard! Fax your elected representatives with #Artifax\"\n" +
    "                share-tw-url=\"https://artifax.us/\"\n" +
    "                ng-include=\"'assets/images/twitter.svg'\">\n" +
    "            </a>\n" +
    "            <a\n" +
    "                class=\"footer__item\"\n" +
    "                share-fb\n" +
    "                share-fb-url=\"https://artifax.us/\"\n" +
    "                ng-include=\"'assets/images/facebook.svg'\">\n" +
    "            </a>\n" +
    "            <a\n" +
    "                class=\"footer__item\"\n" +
    "                share-e\n" +
    "                share-e-body=\"Fax%20your%20elected%20representatives%20and%20let%20them%20know%20your%20views%20with%20https%3A%2F%2Fartifax.us\"\n" +
    "                share-e-subject=\"Let%20your%20voice%20be%20heard%21\"\n" +
    "                ng-include=\"'assets/images/email.svg'\">\n" +
    "            </a>\n" +
    "        </div>\n" +
    "        <div class=\"footer__company\">\n" +
    "            <span class=\"footer__company__text\">Made by</span>\n" +
    "            <a\n" +
    "                class=\"footer__item footer__logo\"\n" +
    "                href=\"http://useallfive.com\"\n" +
    "                target=\"_blank\"\n" +
    "                ng-mouseenter=\"showText()\"\n" +
    "                ng-mouseleave=\"hideText()\"\n" +
    "                ng-include=\"'assets/images/UA5_Artifax_Hand.svg'\">\n" +
    "            </a>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "</div>\n"
  );


  $templateCache.put('components/intro/intro.html',
    "<div\n" +
    "    class=\"intro\"\n" +
    "    ng-class=\"{dismissed: introDismissed, 'hide-intro': hideIntro}\">\n" +
    "	<div class=\"intro__exclamations\">\n" +
    "        <div\n" +
    "            class=\"intro__exclamation one\"\n" +
    "            ng-include=\"'assets/images/exclamation.svg'\"\n" +
    "            onload=\"finishedLoading1()\">\n" +
    "        </div>\n" +
    "        <div\n" +
    "            class=\"intro__exclamation two\"\n" +
    "            ng-include=\"'assets/images/exclamation.svg'\"\n" +
    "            onload=\"finishedLoading2()\">\n" +
    "        </div>\n" +
    "        <div\n" +
    "            class=\"intro__exclamation three\"\n" +
    "            ng-include=\"'assets/images/exclamation.svg'\"\n" +
    "            onload=\"finishedLoading3()\">\n" +
    "        </div>\n" +
    "    </div>\n" +
    "</div>\n"
  );


  $templateCache.put('components/logo/logo.html',
    "<div\n" +
    "    class=\"logo\"\n" +
    "    ng-class=\"{'intro-showing': !introDismissed}\">\n" +
    "    <img width=\"100%\" src=\"/assets/images/Artifax-Logo-july2018Update.png\">\n" +
    "</div>\n"
  );


  $templateCache.put('components/nav/nav.html',
    "<div class=\"nav\">\n" +
    "	<a\n" +
    "        class=\"nav__link\"\n" +
    "        ui-sref-active=\"active\"\n" +
    "        ui-sref=\"about\">\n" +
    "        About Artifax\n" +
    "        <span></span>\n" +
    "        <span></span>\n" +
    "        <span></span>\n" +
    "        <span></span>\n" +
    "    </a>\n" +
    "    <a\n" +
    "        class=\"nav__link\"\n" +
    "        ui-sref-active=\"active\"\n" +
    "        ui-sref=\"contribute\">\n" +
    "        Contribute an Artwork\n" +
    "        <span></span>\n" +
    "        <span></span>\n" +
    "        <span></span>\n" +
    "        <span></span>\n" +
    "    </a>\n" +
    "    <a\n" +
    "        class=\"nav__link\"\n" +
    "        href=\"https://useallfive.com\"\n" +
    "        target=\"_blank\">\n" +
    "        Organized by Use All Five\n" +
    "        <span></span>\n" +
    "        <span></span>\n" +
    "        <span></span>\n" +
    "        <span></span>\n" +
    "    </a>\n" +
    "</div>\n" +
    "<div\n" +
    "    class=\"nav-mobile\"\n" +
    "    ng-class=\"{open: mobileNavOpen}\">\n" +
    "    <div\n" +
    "        class=\"nav-mobile__toggle\"\n" +
    "        ng-click=\"toggleMobileNav()\">\n" +
    "        <span></span>\n" +
    "        <span></span>\n" +
    "        <span></span>\n" +
    "    </div>\n" +
    "    <div class=\"nav-mobile__body\">\n" +
    "        <a\n" +
    "            class=\"nav-mobile__link\"\n" +
    "            ui-sref=\"home\"\n" +
    "            ui-sref-active=\"active\"\n" +
    "            ng-click=\"mobileNavOpen = false\">\n" +
    "            Home\n" +
    "        </a>\n" +
    "        <a\n" +
    "            class=\"nav-mobile__link\"\n" +
    "            ui-sref=\"about\"\n" +
    "            ui-sref-active=\"active\"\n" +
    "            ng-click=\"mobileNavOpen = false\">\n" +
    "            About Artifax\n" +
    "        </a>\n" +
    "        <a\n" +
    "            class=\"nav-mobile__link\"\n" +
    "            href=\"https://www.arts.gov/partners/state-regional\"\n" +
    "            target=\"_blank\"\n" +
    "            ng-click=\"mobileNavOpen = false\">\n" +
    "            Support Local Arts\n" +
    "        </a>\n" +
    "    </div>\n" +
    "</div>\n"
  );


  $templateCache.put('components/ticker/ticker.html',
    "<div\n" +
    "    class=\"ticker\"\n" +
    "    ng-class=\"{'intro-dismissed': introDismissed}\">\n" +
    "    <div class=\"ticker__inner\">\n" +
    "    	<div class=\"ticker__messages\">\n" +
    "            <div\n" +
    "                class=\"ticker__message\"\n" +
    "                ng-repeat=\"message in messages\">\n" +
    "                <div class=\"ticker__message__inner\">\n" +
    "                    <span class=\"ticker__message__leadin\">\n" +
    "                        Latest News\n" +
    "                    </span>\n" +
    "                    <span class=\"ticker__message__dash\">\n" +
    "                    </span>\n" +
    "                    <span\n" +
    "                        class=\"ticker__message__text\"\n" +
    "                        ng-bind-html=\"message\">\n" +
    "                    </span>\n" +
    "                </div>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "</div>\n"
  );


  $templateCache.put('index.unprocessed.html',
    "<!DOCTYPE html>\n" +
    "<html\n" +
    "    class=\"no-js\"\n" +
    "    ng-class=\"{'intro-showing': !introDismissed, 'preparing-fax': preparingFax}\"\n" +
    "    lang=\"en\"\n" +
    "    data-ng-app=\"ua5App\"\n" +
    "    ng-strict-di=\"true\"\n" +
    "    data-ng-cloak\n" +
    "    data-app>\n" +
    "    <head>\n" +
    "        <meta charset=\"utf-8\">\n" +
    "        <meta name=\"fragment\" content=\"!\">\n" +
    "        <base href=\"/\">\n" +
    "        <!-- @if PRODUCTION='false' -->\n" +
    "        <script src=\"bower_components/angular/angular.js\"></script>\n" +
    "        <!-- @endif -->\n" +
    "        <link\n" +
    "            href=\"https://fonts.googleapis.com/css?family=Poppins:500\"\n" +
    "            rel=\"stylesheet\"\n" +
    "            type=\"text/css\">\n" +
    "        <!-- @if TESTING='true' -->\n" +
    "        <link\n" +
    "            href=\"_build/assets/css/app.css\"\n" +
    "            rel=\"stylesheet\"\n" +
    "            type=\"text/css\">\n" +
    "        <!-- @endif -->\n" +
    "        <!-- @if TESTING='false' -->\n" +
    "        <link\n" +
    "            href=\"assets/css/app.css?v=2\"\n" +
    "            rel=\"stylesheet\"\n" +
    "            type=\"text/css\">\n" +
    "        <!-- @endif -->\n" +
    "        <meta name=\"viewport\" content=\"width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no\">\n" +
    "        <title ng-bind=\"ngMeta.title\">\n" +
    "            Artifax — Take Action! Fax Congress with Art\n" +
    "        </title>\n" +
    "        <meta\n" +
    "            name=\"description\"\n" +
    "            content=\"Let your voice be heard! Fax your elected representatives and let them know your views.\">\n" +
    "        <meta\n" +
    "            property=\"og:description\"\n" +
    "            content=\"Let your voice be heard! Fax your elected representatives and let them know your views.\">\n" +
    "        <meta\n" +
    "            property=\"og:image\"\n" +
    "            content=\"https://artifax.us/assets/images/artifax-social.jpg\">\n" +
    "        <meta\n" +
    "            property=\"og:site_name\"\n" +
    "            content=\"Artifax\">\n" +
    "        <meta\n" +
    "            property=\"og:url\"\n" +
    "            content=\"https://artifax.us\">\n" +
    "        <meta\n" +
    "            property=\"og:type\"\n" +
    "            content=\"website\">\n" +
    "        <meta\n" +
    "            name=\"twitter:site\"\n" +
    "            content=\"@useallfive\">\n" +
    "        <meta\n" +
    "            name=\"twitter:card\"\n" +
    "            content=\"summary_large_image\">\n" +
    "        <meta\n" +
    "            property=\"twitter:description\"\n" +
    "            content=\"Let your voice be heard! Fax your elected representatives and let them know your views.\">\n" +
    "        <meta\n" +
    "            name=\"twitter:title\"\n" +
    "            content=\"Artifax — Fax Congress with Art\">\n" +
    "        <meta name=\"twitter:creator\" content=\"@useallfive\">\n" +
    "        <meta name=\"twitter:image\" content=\"https://artifax.us/assets/images/artifax-social.jpg\">\n" +
    "\n" +
    "        <link\n" +
    "            href=\"assets/images/favicon.png\"\n" +
    "            rel=\"icon\"\n" +
    "            type=\"image/png\">\n" +
    "    </head>\n" +
    "    <body ng-class=\"pageClass\">\n" +
    "        <noscript>\n" +
    "            <div class=\"noscript\">\n" +
    "                Please enable JavaScript on your browser or upgrade to <a href=\"http://www.google.com/chrome/\" target=\"_blank\">Google Chrome</a> to use Artifax.\n" +
    "            </div>\n" +
    "        </noscript>\n" +
    "        <!--<div fax-generator></div>-->\n" +
    "        <div\n" +
    "            class=\"index__intro\"\n" +
    "            intro>\n" +
    "        </div>\n" +
    "        <a\n" +
    "            class=\"index__logo\"\n" +
    "            ng-class=\"{'intro-showing': !introDismissed}\"\n" +
    "            ui-sref=\"home\"\n" +
    "            logo>\n" +
    "        </a>\n" +
    "        <!--<div-->\n" +
    "            <!--class=\"index__ticker\"-->\n" +
    "            <!--ticker>-->\n" +
    "        </div>\n" +
    "        <div\n" +
    "            class=\"index__nav\"\n" +
    "            nav>\n" +
    "        </div>\n" +
    "        <div\n" +
    "            ui-view\n" +
    "            class=\"index__view fade\">\n" +
    "        </div>\n" +
    "        <div footer></div>\n" +
    "        <script src=\"https://maps.googleapis.com/maps/api/js?key=AIzaSyB92j-FuwnfETYLvSWfeiKRJkJdfYsFNoY&libraries=places\"></script>\n" +
    "        <script>\n" +
    "            (function(i,s,o,g,r,a,m){i['GoogleAnalyticsObject']=r;i[r]=i[r]||function(){\n" +
    "            (i[r].q=i[r].q||[]).push(arguments)},i[r].l=1*new Date();a=s.createElement(o),\n" +
    "            m=s.getElementsByTagName(o)[0];a.async=1;a.src=g;m.parentNode.insertBefore(a,m)\n" +
    "            })(window,document,'script','https://www.google-analytics.com/analytics.js','ga');\n" +
    "\n" +
    "            ga('create', 'UA-729216-35', 'auto');\n" +
    "        </script>\n" +
    "        <!-- @if PRODUCTION='true' -->\n" +
    "            <!-- @if TESTING='true' -->\n" +
    "            <script src=\"_build/vendor.js\"></script>\n" +
    "            <script src=\"_build/app.js\"></script>\n" +
    "            <!-- @endif -->\n" +
    "            <!-- @if TESTING='false' -->\n" +
    "            <script src=\"vendor.js?v=2\"></script>\n" +
    "            <script src=\"app.js?v=2\"></script>\n" +
    "            <!-- @endif -->\n" +
    "        <!-- @endif -->\n" +
    "        <!-- @if PRODUCTION='false' -->\n" +
    "        <!-- start bower_components -->\n" +
    "        <script src=\"bower_components/jquery/dist/jquery.js\"></script>\n" +
    "        <script src=\"bower_components/angulartics/src/angulartics.js\"></script>\n" +
    "        <script src=\"bower_components/angulartics-google-analytics/lib/angulartics-google-analytics.js\"></script>\n" +
    "        <script src=\"bower_components/angular-resource/angular-resource.js\"></script>\n" +
    "        <script src=\"bower_components/angular-sanitize/angular-sanitize.js\"></script>\n" +
    "        <script src=\"bower_components/angular-touch/angular-touch.js\"></script>\n" +
    "        <script src=\"bower_components/angular-animate/angular-animate.js\"></script>\n" +
    "        <script src=\"bower_components/angular-ui-router/release/angular-ui-router.js\"></script>\n" +
    "        <script src=\"bower_components/angular-loading-bar/build/loading-bar.js\"></script>\n" +
    "        <script src=\"bower_components/gsap/src/uncompressed/TweenMax.js\"></script>\n" +
    "        <script src=\"bower_components/gsap/src/uncompressed/TimelineMax.js\"></script>\n" +
    "        <script src=\"bower_components/gsap/src/uncompressed/plugins/ScrollToPlugin.js\"></script>\n" +
    "        <script src=\"bower_components/imagesloaded/imagesloaded.pkgd.js\"></script>\n" +
    "        <script src=\"bower_components/underscore/underscore.js\"></script>\n" +
    "        <script src=\"bower_components/slick-carousel/slick/slick.js\"></script>\n" +
    "        <script src=\"bower_components/ngMeta/dist/ngMeta.js\"></script>\n" +
    "        <script src=\"bower_components/jquery-unorphanize/unorphanize.jquery.js\"></script>\n" +
    "        <script src=\"bower_components/angular-modal-service/dst/angular-modal-service.js\"></script>\n" +
    "        <script src=\"bower_components/modernizr/modernizr.js\"></script>\n" +
    "        <script src=\"bower_components/signature_pad/signature_pad.min.js\"></script>\n" +
    "        <script src=\"bower_components/moment/moment.js\"></script>\n" +
    "        <script src=\"bower_components/angular-elastic/elastic.js\"></script>\n" +
    "        <script src=\"bower_components/ng-file-upload/ng-file-upload.js\"></script>\n" +
    "        <!-- end bower_components -->\n" +
    "        <script src=\"app.js\"></script>\n" +
    "        <!-- resources scripts -->\n" +
    "        <script src=\"resources/artworks.js\"></script>\n" +
    "        <script src=\"resources/browsers.js\"></script>\n" +
    "        <script src=\"resources/legislators.js\"></script>\n" +
    "        <!-- end resources scripts -->\n" +
    "        <!-- state scripts -->\n" +
    "        <script src=\"states/home/home.js\"></script>\n" +
    "        <script src=\"states/about/about.js\"></script>\n" +
    "        <script src=\"states/contribute/contribute.js\"></script>\n" +
    "        <script src=\"states/terms/terms.js\"></script>\n" +
    "        <!-- end state scripts -->\n" +
    "        <!-- component scripts -->\n" +
    "        <script src=\"components/unorphanize/unorphanize.js\"></script>\n" +
    "        <script src=\"components/scroll-reveal/scroll-reveal.js\"></script>\n" +
    "        <script src=\"components/share-fb/share-fb.js\"></script>\n" +
    "        <script src=\"components/share-tw/share-tw.js\"></script>\n" +
    "        <script src=\"components/share-e/share-e.js\"></script>\n" +
    "        <script src=\"components/intro/intro.js\"></script>\n" +
    "        <script src=\"components/logo/logo.js\"></script>\n" +
    "        <script src=\"components/ticker/ticker.js\"></script>\n" +
    "        <script src=\"components/nav/nav.js\"></script>\n" +
    "        <script src=\"components/fax/fax.js\"></script>\n" +
    "        <script src=\"components/artwork/artwork.js\"></script>\n" +
    "        <script src=\"components/fax-page/fax-page.js\"></script>\n" +
    "        <script src=\"components/fax-generator/fax-generator.js\"></script>\n" +
    "        <script src=\"components/contact-form/contact-form.js\"></script>\n" +
    "        <script src=\"components/contribute-form/contribute-form.js\"></script>\n" +
    "        <script src=\"components/footer/footer.js\"></script>\n" +
    "        <!-- end component scripts -->\n" +
    "        <!-- services scripts -->\n" +
    "        <script src=\"services/preloader.js\"></script>\n" +
    "        <script src=\"services/popup.js\"></script>\n" +
    "        <!-- end services scripts -->\n" +
    "        <!-- animations scripts -->\n" +
    "        <script src=\"animations/fade.js\"></script>\n" +
    "        <script src=\"animations/fade-child.js\"></script>\n" +
    "        <!-- end animations scripts -->\n" +
    "        <!-- @endif -->\n" +
    "    </body>\n" +
    "</html>\n"
  );


  $templateCache.put('states/about/about.html',
    "<div class=\"about\">\n" +
    "    <div\n" +
    "        class=\"about__intro-image\"\n" +
    "        ng-style={'background-image':'url(/assets/images/about/1.jpg)'}>\n" +
    "    </div>\n" +
    "    <div class=\"about__intro-text\">\n" +
    "        Artifax is a project organized by <a href=\"http://www.useallfive.com/\" target=\"_blank\">Use All Five</a> to connect people with their elected representatives. It began as a tool to urge congress to protect the National Endowment for the Arts; however, we have been inspired to expand it.\n" +
    "    </div>\n" +
    "    <div class=\"about__faq\">\n" +
    "        <div class=\"about__faq__question\">\n" +
    "            How did Artifax begin?\n" +
    "        </div>\n" +
    "        <div class=\"about__faq__answer\">\n" +
    "            When Trump’s <a href=\"https://www.nytimes.com/interactive/2017/03/16/us/politics/document-Trump-2018-Budget.html\" target=\"_blank\">First Budget Proposal</a> was released in 2017, the National Endowment of the Arts (NEA) was on the chopping block. The Proposal described this decision as part of a move to veer away from programs unfit for “the proper role of the Federal Government” and reduce spending in the national budget. But here’s the thing: the NEA makes only <a href=\"https://www.washingtonpost.com/news/the-fix/wp/2017/01/19/trump-reportedly-wants-to-cut-cultural-programs-that-make-up-0-02-percent-of-federal-spending/?utm_term=.cdab35f762c1\" target=\"_blank\">a tiny fraction</a> of the nation’s discretionary spending. And some suspected that this threat is part of a broader, ideologically-motivated attack on the arts themselves.<br><br>\n" +
    "            In response, Use All Five created Artifax to help spread the word to Congress on exactly how and why the NEA is a vital piece of the funding-pie for the arts in this country.\n" +
    "        </div>\n" +
    "    </div>\n" +
    "    <div class=\"about__faq\">\n" +
    "        <div class=\"about__faq__question\">\n" +
    "            What inspired it to expand?\n" +
    "        </div>\n" +
    "        <div class=\"about__faq__answer\">\n" +
    "            Since the initial budget proposal that was released in 2017, there has been a deluge of issues that have inspired people to organize and raise their voice. Some of these issues may only have a short period under the national spotlight, and require us to immediately make our views known in order to have the greatest impact on decision-makers. We broadened the platform to help anyone reach out to their representatives at anytime and on any issue they care about via fax.\n" +
    "        </div>\n" +
    "    </div>\n" +
    "    <div class=\"about__images\">\n" +
    "        <div\n" +
    "            class=\"about__images-item\"\n" +
    "            data-image-tilt>\n" +
    "            <div\n" +
    "                class=\"about__images-item__image\"\n" +
    "                ng-style={'background-image':'url(/assets/images/about/protest.jpg)'}>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "    <div class=\"about__faq\">\n" +
    "        <div class=\"about__faq__question\">\n" +
    "            Why fax?\n" +
    "        </div>\n" +
    "        <div class=\"about__faq__answer\">\n" +
    "            Calling Congress is important. The aspect of human, direct contact that phone calls provide <a href=\"https://www.wired.com/2017/02/call-congress-phone-system-broken/\" target=\"_blank\">make them much more impactful than emails</a>, which can be easy for staffers to ignore. However voicemails get full, and faxes still have that material impact that commands attention; they’re physical, and inconveniencing, and that’s what it takes to convey an impactful message to your representatives.<br><br>\n" +
    "            We do want to acknowledge that some faxes may not be physically printed. A fax's final format really depends on the individual congressional office, and what tools they choose to use; older fax machines print physical copies, while newer ones may convert digitally. While we don’t have the data on which congressional offices field print or digital faxes, we do know that your message has the most impact when it is more personalized. Your unique message, signature, address, registered voter confirmation, and the special artwork you choose, will help make staffers pay attention.\n" +
    "        </div>\n" +
    "    </div>\n" +
    "    <div\n" +
    "        class=\"about__fax-image\"\n" +
    "        ng-style={'background-image':'url(/assets/images/about/4.jpg)'}>\n" +
    "    </div>\n" +
    "    <div\n" +
    "        class=\"about__contact\"\n" +
    "        contact-form>\n" +
    "    </div>\n" +
    "</div>\n"
  );


  $templateCache.put('states/contribute/contribute.html',
    "<div class=\"contribute\">\n" +
    "	<div class=\"contribute__intro\">\n" +
    "        <div class=\"contribute__intro__header\">\n" +
    "            Interested in contributing an artwork?\n" +
    "        </div>\n" +
    "        <div class=\"contribute__intro__subheader\">\n" +
    "            We’d love to hear from you! Please submit the following form and attach your artwork at the specifications listed for our consideration.\n" +
    "        </div>\n" +
    "    </div>\n" +
    "    <div\n" +
    "        class=\"contribute__submission\"\n" +
    "        contribute-form>\n" +
    "    </div>\n" +
    "</div>\n"
  );


  $templateCache.put('states/home/home.html',
    "<div class=\"home\">\n" +
    "    <div\n" +
    "        class=\"home__artworks\"\n" +
    "        ng-class=\"{'preparing-fax': preparingFax, 'selecting-artwork': selectingArtwork}\">\n" +
    "        <div class=\"home__artworks__intro\">\n" +
    "            <div class=\"home__artworks__intro__text\">\n" +
    "                Let your voice be heard! Fax your elected representatives and let them know your views. Select an artwork that resonates the most with you, add your message, and we’ll fax it to your congressperson.\n" +
    "            </div>\n" +
    "            <div class=\"home__artworks__intro__cta\">\n" +
    "                <span class=\"home__artworks__intro__cta__desktop-text\">Select an artwork to begin</span>\n" +
    "                <span class=\"home__artworks__intro__cta__mobile-text\">Swipe to select an artwork</span>\n" +
    "                <div\n" +
    "                    class=\"home__artworks__intro__cta__arrow\"\n" +
    "                    ng-include=\"'assets/images/down-arrow.svg'\"></div>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "        <div\n" +
    "            class=\"home__artworks__loading\"\n" +
    "            ng-show=\"loadingArtwork\">\n" +
    "            <div class=\"home__artworks__loading__inner\">\n" +
    "                Loading...\n" +
    "            </div>\n" +
    "        </div>\n" +
    "        <div class=\"home__artworks__list\">\n" +
    "            <div\n" +
    "                class=\"home__artworks__artwork\"\n" +
    "                ng-repeat=\"artwork in artworksList\"\n" +
    "                artwork\n" +
    "                artwork-data=\"artwork\">\n" +
    "            </div>\n" +
    "        </div>\n" +
    "        <div class=\"home__artworks__overlay\">\n" +
    "            <div class=\"home__artworks__fax-artwork-choice prev\">\n" +
    "                <div\n" +
    "                    class=\"home__artworks__fax-artwork-choice__arrow\"\n" +
    "                    ng-click=\"changeArtwork()\"\n" +
    "                    ng-include=\"'assets/images/back-arrow.svg'\">\n" +
    "                </div>\n" +
    "                <div\n" +
    "                    class=\"home__artworks__fax-artwork-choice__artwork\"\n" +
    "                    ng-click=\"changeArtwork()\">\n" +
    "                    <img\n" +
    "                        class=\"home__artworks__fax-artwork-choice__artwork__image\"\n" +
    "                        ng-src=\"{{prevFaxArtwork.image}}\">\n" +
    "                </div>\n" +
    "            </div>\n" +
    "            <div class=\"home__artworks__fax-artwork-choice next\">\n" +
    "                <div\n" +
    "                    class=\"home__artworks__fax-artwork-choice__arrow\"\n" +
    "                    ng-click=\"changeArtwork(true)\"\n" +
    "                    ng-include=\"'assets/images/back-arrow.svg'\">\n" +
    "                </div>\n" +
    "                <div\n" +
    "                    class=\"home__artworks__fax-artwork-choice__artwork\"\n" +
    "                    ng-click=\"changeArtwork(true)\">\n" +
    "                    <img\n" +
    "                        class=\"home__artworks__fax-artwork-choice__artwork__image\"\n" +
    "                        ng-src=\"{{nextFaxArtwork.image}}\">\n" +
    "                </div>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "        <div\n" +
    "            class=\"fax-wrapper\"\n" +
    "            fax\n" +
    "            fax-artwork=\"faxArtwork\"\n" +
    "            exit-fax=\"exitFax()\"\n" +
    "            prev-artwork=\"changeArtwork()\"\n" +
    "            next-artwork=\"changeArtwork(true)\">\n" +
    "        </div>\n" +
    "    </div>\n" +
    "    <div class=\"home__artists\">\n" +
    "        <div class=\"home__artists__title\">Contributors</div>\n" +
    "        <ul class=\"home__artists__list\">\n" +
    "            <li\n" +
    "                class=\"home__artists__artist\"\n" +
    "                ng-repeat=\"artist in artists\">\n" +
    "                <a\n" +
    "                    class=\"home__artsits__link\"\n" +
    "                    ng-class=\"{'home__artsits__link--none': artist.url === ''}\"\n" +
    "                    href=\"{{artist.url}}\"\n" +
    "                    target=\"_blank\">\n" +
    "                    {{artist.name}}\n" +
    "                </a>\n" +
    "            </li>\n" +
    "        </ul>\n" +
    "        <a\n" +
    "            class=\"home__artists__contribute\"\n" +
    "            ui-sref=\"contribute\">\n" +
    "            Contribute an artwork\n" +
    "        </a>\n" +
    "    </div>\n" +
    "</div>\n"
  );


  $templateCache.put('states/terms/terms.html',
    "<div class=\"terms\">\n" +
    "	<div class=\"terms-headline\">\n" +
    "        Terms of Agreement\n" +
    "    </div>\n" +
    "    <ol class=\"terms__group\">\n" +
    "        <li\n" +
    "            class=\"terms__item\"\n" +
    "            ng-repeat=\"term in terms\">\n" +
    "            <div\n" +
    "                class=\"terms__item__title\"\n" +
    "                ng-bind-html=\"term.title\">\n" +
    "            </div>\n" +
    "            <div\n" +
    "                ng-if=\"term.description\"\n" +
    "                class=\"terms__item__description\"\n" +
    "                ng-bind-html=\"term.description\">\n" +
    "            </div>\n" +
    "            <ol\n" +
    "                ng-if=\"term.subpoints\"\n" +
    "                class=\"term__item__subgroup\">\n" +
    "                <li\n" +
    "                    class=\"term__subgroup__item\"\n" +
    "                    ng-repeat=\"subitem in term.subpoints\">\n" +
    "                    <div\n" +
    "                        class=\"subitem__description\"\n" +
    "                        ng-bind-html=\"subitem.description\">\n" +
    "                    </div>\n" +
    "                    <ol\n" +
    "                        ng-if=\"subitem.secondarySubpoints\"\n" +
    "                        class=\"subitem__subgroup\">\n" +
    "                        <li\n" +
    "                            class=\"subitem__subgroup__item\"\n" +
    "                            ng-repeat=\"sub in subitem.secondarySubpoints\"\n" +
    "                            ng-bind-html=\"sub.description\">\n" +
    "                        </li>\n" +
    "                    </ol>\n" +
    "                </li>\n" +
    "            </ol>\n" +
    "        </li>\n" +
    "    </ol>\n" +
    "    <div class=\"terms-headline terms-headline__policy\">\n" +
    "        Privacy Policy\n" +
    "    </div>\n" +
    "    <div class=\"terms__group terms__group-policy\">\n" +
    "        <div\n" +
    "            class=\"terms__item\"\n" +
    "            ng-repeat=\"policy in privacy\">\n" +
    "            <div\n" +
    "                ng-if=\"policy.title\"\n" +
    "                class=\"terms__item__title\"\n" +
    "                ng-bind-html=\"policy.title\">\n" +
    "            </div>\n" +
    "            <div\n" +
    "                ng-if=\"policy.description\"\n" +
    "                class=\"terms__item__description\"\n" +
    "                ng-bind-html=\"policy.description\">\n" +
    "            </div>\n" +
    "            <ul\n" +
    "                ng-if=\"policy.subpoints\"\n" +
    "                class=\"term__item__subgroup term__item__subgroup-bullet\">\n" +
    "                <li\n" +
    "                    class=\"term__subgroup__item\"\n" +
    "                    ng-repeat=\"subitem in policy.subpoints\"\n" +
    "                    ng-bind-html=\"subitem.description\">\n" +
    "                </li>\n" +
    "            </ul>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "</div>\n"
  );

}]);

//# sourceMappingURL=app.js.map